// sn — checkin/quickCheck/stepTracker blocks translated.
export const sn = {
  "common": {
    "loading": "Zvichitakura...",
    "save": "Chengetedza",
    "cancel": "Kanzura",
    "delete": "Dzima",
    "edit": "Gadzirisa",
    "close": "Vhara",
    "confirm": "Simbisa",
    "back": "Dzokera",
    "next": "Mberi",
    "submit": "Tumira",
    "search": "Tsvaga",
    "select": "Sarudza",
    "or": "Kana",
    "and": "uye",
    "note": "Cherechedza",
    "viewAll": "Wona Zvese",
    "learnMore": "Dzidza Zvakawanda",
    "getStarted": "Tanga Pano",
    "continue": "Enderera Mberi",
    "saving": "Zvichichengetedza…"
  },
  "nav": {
    "dashboard": "Pamba",
    "nutrition": "Zvekudya",
    "family": "Mhuri",
    "care": "Zveutano",
    "careShort": "Zveutano",
    "checkIn": "Kuongorora Utano",
    "insights": "Ruzivo rweUtano",
    "trends": "Zvirikuitika",
    "habits": "Zvaunogara Uchiita",
    "medications": "Mishonga",
    "expertSupport": "Rubatsiro rweNyanzvi",
    "profile": "Zvakakuverenga",
    "healthHub": "Health Hub",
    "support": "Rubatsiro",
    "wellness": "Utano Hwakanaka",
    "education": "Dzidzo",
    "community": "Nharaunda",
    "preventiveHealth": "Kudzivirira Chirwere",
    "womensHealth": "Utano hweVadzimai",
    "reminders": "Zviyeuchidzo zveUtano",
    "meals": "Zvekudya",
    "orders": "Zvatengwa",
    "subscription": "Kunyoresa",
    "logout": "Buda"
  },

  "navShort": {
    "dashboard": "Kumba",
    "nutrition": "Chikafu",
    "family": "Mhuri",
    "care": "Masevhisi",
    "support": "Rubatsiro",
    "profile": "Mufananidzo"
  },
  "auth": {
    "login": "Pinda",
    "register": "Gadzira Akaundi",
    "logout": "Buda",
    "email": "Email",
    "password": "Password",
    "name": "Zita Rakazara",
    "forgotPassword": "Wakanganwa Password?",
    "noAccount": "Hauna akaundi here?",
    "haveAccount": "Wakatova neakaundi?",
    "signInHere": "Pindira pano",
    "signUpHere": "Gadzira pano",
    "welcomeBack": "Mauya zvekare!",
    "getStarted": "Ngatitangei",
    "biometricLogin": "Pinda uchishandisa Biometrics",
    "biometricHelper": "Shandisa munwe, chiso, kana Windows Hello",
    "vendorLogin": "Kupinda kweVatengesi",
    "createOne": "Gadzira imwe",
    "tagline": "Chengetedza utano hwako — ongororo imwe chete iri nyore pazuva.",
    "takes30s": "Hazvitori masekonzi makumi matatu",
    "emailPlaceholder": "zita@email.com",
    "passwordPlaceholder": "Pinza password yako",
    "checking": "Zvichiongororwa…",
    "continue": "Enderera mberi",
    "secureMessage": "Izvi zvakachengetedzeka — ruzivo rwako haruburitswi",
    "biometricSoon": "Kupinda neBiometric — Zviri kuuya munguva pfupi",
    "sessionExpired": "Nguva yako yapera. Ndapota pinda zvekare kuti uenderere mberi nepatasira.",
    "showPassword": "Ratidza password",
    "hidePassword": "Viga password",
    "vendor": {
      "title": "Kupinda kweVatengesi (Vendor)",
      "subtitle": "Pinda pane dhibhodhi revatengesi veHealthLoop",
      "businessEmail": "Email rebhizinesi",
      "emailPlaceholder": "mutengesi@bhizinesi.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "Kupinda...",
      "signIn": "Pinda",
      "notVendorYet": "Hausi mutengesi wedu here?",
      "registerBusiness": "Nengetedza bhizinesi rako",
      "areYouUser": "Uri mushandisi (user) here?",
      "userLogin": "Kupinda kweMushandisi",
      "welcomeBackToast": "Mauya zvekare!",
      "genericError": "Kupinda kwaramba. Tapota edza zvekare."
    },
    "admin": {
      "backToUserLogin": "Kupinda kwemushandisi",
      "title": "Kupinda kweVatariri (Admin)",
      "restrictedBadge": "Zvinorambidzwa",
      "tagline": "HealthLoop operator console — kudiwa ruzivo rwevatariri.",
      "emailLabel": "Email yeAdmin",
      "emailPlaceholder": "admin@domainrako.com",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Pinza password yako yeadmin",
      "signingIn": "Kupinda…",
      "submit": "Pinda mune ruzivo rweadmin",
      "secureNote": "Kwese kwakachengetedzwa · ruzivo rwakavharidzirwa",
      "restrictedTitle": "Ino inzvimbo yevatariri chete.",
      "restrictedBody": "Account yako yapinda, asi haina mvumo ye vatariri. Buda kuti upinde neimwe account, kana kudzokera kune rimwe divi reapp.",
      "signOut": "Buda",
      "backToApp": "Dzokera kuApp"
    }
  },
  "quickCheck": {
    "header": {
      "title": "Uri kunzwa sei nhasi?",
      "subtitle": "Kuongorora kwekukasira — zvinotora pasi pesekondi makumi makumi matanhatu"
    },
    "section1": {
      "title": "Chii chauri kucherechedza nhasi?",
      "hint": "(Sarudza zvose zviripo)"
    },
    "environment": {
      "title": "Zvakakupoteredza nhasi",
      "hint": "Tibatsire kunzwisisa kwawakange uri"
    },
    "basicChecks": {
      "title": "Kuongorora kwezvinokosha",
      "hint": "Kana uchida hako asi kunobatsira"
    },
    "validation": {
      "pickOne": "Ndapota pinda mubvunzo ungapange umwe chete"
    },
    "submit": {
      "cta": "Wana Ruzivo rweUtano Hwangu",
      "saving": "Kuchengetedza...",
      "analyzing": "Kuongorora mafambiro eutano hwako...",
      "savedToast": "✅ Kuongorora kuchengetedzwa! Kuongorora mafambiro eutano hwako..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "Kuverenga Matanho",
      "subtitle": "Kutevera mashandiro emuviri wako nekuvimbika",
      "backToDashboard": "Dzokera kupeeji reutano"
    },
    "today": {
      "title": "Matanho anhasi",
      "goalProgress": "{{current}} / {{goal}} matanho",
      "goalReached": "Wasvika pamatanho wawaida — basa rakanaka!",
      "keepGoing": "Enderera mberi — uri kufamba zvakanaka."
    },
    "streak": {
      "label": "Mazuva akatevedzana",
      "days": "Zuva re {{count}}",
      "daysPlural": "Mazuva {{count}}"
    },
    "badges": {
      "title": "Mibairo",
      "empty": "Uchawana mibairo sezvo uchiita tsika iyi."
    },
    "reminders": {
      "title": "Zviyeuchidzo zvekufamba",
      "hint": "Zviyeuchidzo zvinyoro zvekumbofamba-famba mushure mekugara kwenguva refu.",
      "enabled": "Zvichishanda",
      "disabled": "Hazvisi kushanda"
    },
    "insights": {
      "weeklyAverage": "Huwandu hwevhiki",
      "weeklyGoal": "Zvinangwa zvevhiki"
    },
    "actions": {
      "connect": "Gadzira bumbiro rematanho",
      "manualLog": "Pinda matanho nemaoko",
      "changeGoal": "Chinja zvinangwa zvezuva"
    }
  },
  "checkin": {
    "header": {
      "title": "Kuongorora Utano Kwezuva neZuva",
      "subtitle": "Zvinotora nguva iri pasi pesekondi makumi matanhatu",
      "restDayLink": "Handisi kuzvinzwa zvakanaka nhasi"
    },
    "snapshot": {
      "title": "Peeji rako reutano, rakagadziriswa",
      "healthScore": "Chibodzwa cheutano",
      "todayTasks": "Zvekuita nhasi",
      "dayStreak": "kutevedzana kwemazuva"
    },
    "resume": {
      "banner": "Tapfuurira pawakasiira",
      "startFresh": "Tanga patsva",
      "dismiss": "Bvisa"
    },
    "progress": {
      "allSet": "Zvose zvagadzirwa",
      "step": "Danho re {{current}} pa {{total}}",
      "ariaLabel": "Kufambira mberi kwekuongorora kwezuva: {{done}} pa {{total}} zvikamu zvapera"
    },
    "insights": {
      "title": "Ruzivo rweUtano Hwako",
      "subtitle": "Zvakagadzirirwa iwe nhasi",
      "insightForYou": "Ruzivo rwako",
      "simpleActions": "Matanho ari nyore aungatora",
      "whenToSeekHelp": "Nguva yekutsvaga rubatsiro",
      "nhsAdvice": "Kana uine chekudya moyo, bata NHS 111 kana chiremba wako",
      "backToDashboard": "Dzokera kuPeeji reUtano",
      "newCheckIn": "Kuongorora Kutsva",
      "disclaimer": "HealthLoop inopa mazano ekuva noutano hwakanaka, kwete kuongororwa nezvekurwara."
    },
    "restDay": {
      "title": "Kuzorora chikamu chekurongeka kweutano.",
      "body": "Tichange tiri pano mangwana, kana wagadzirira.",
      "streakNote": "Mazuva ako akatevedzana haana kumira — nawo ari kumbozororawo.",
      "backToDashboard": "Dzokera kupeeji reutano",
      "changedMind": "Kutaura chokwadi, ndinoda kuongorora utano hwangu zvakadaro."
    },
    "feelings": {
      "title": "Uri kunzwa sei nhasi?",
      "hint": "Sarudza zvose zvauri kunzwa",
      "tired": "Ndiri kunzwa kuneta",
      "headache": "Kutemwa nemusoro",
      "stressed": "Kushushikana mupfungwa",
      "pain": "Kurwadziwa kwemuviri",
      "okay": "Ndiri kunzwa zvakanaka nhasi"
    },
    "basics": {
      "title": "Zvinokosha kwauri",
      "sleepQ": "Warara zvakanaka here nezuro husiku?",
      "waterQ": "Wamwa mvura yakakwana here nhasi?",
      "foodQ": "Wadya zvakanaka here nhasi?",
      "activityQ": "Wange wakashanda zvakadii nhasi?",
      "yes": "Hongu",
      "notReally": "Kwete zvakanyanya",
      "notYet": "Hatisati",
      "notActive": "Handina kumboshanda",
      "lightActivity": "Basa rakareruka",
      "active": "Ndange ndichishanda nesimba"
    },
    "mind": {
      "title": "Pfungwa nesimba",
      "stressQ": "Kushushikana kwako kwakadii nhasi?",
      "moodQ": "Mufaro wako wakadii nhasi?",
      "energyQ": "Simba rako rakadii nhasi?",
      "low": "Pasi",
      "moderate": "Pakati nepakati",
      "high": "Pamusoro",
      "neutral": "Hapana divi randakarerekera",
      "good": "Zvakanaka",
      "okay": "Zviri nani"
    },
    "day": {
      "title": "Zuva rako",
      "routineQ": "Watevedza here zvaunogara uchiita nhasi?",
      "yes": "Hongu",
      "no": "Kwete"
    },
    "environment": {
      "title": "Zvakakupoteredza nhasi",
      "describeQ": "Ungatsanangura sei zvakakupoteredza?",
      "comfortable": "😊 Zvakadekara",
      "slightlyUncomfortable": "😐 Hazvina kunyatsonaka",
      "challenging": "😓 Zvakaoma",
      "affectedQ": "Zvakakupoteredza zvakanganisa manzwiro auri kuita here?",
      "yes": "Hongu",
      "no": "Kwete",
      "exposureLabel": "Zvasangana nemuviri (sarudza zvose zviripo)",
      "heat": "🌡️ Kupisa",
      "cold": "❄️ Chando",
      "noise": "🔊 Ruzha",
      "dustSmoke": "💨 Guruva kana utsi",
      "crowded": "👥 Vanhu vakawanda",
      "none": "✅ Hapana"
    },
    "submit": {
      "analyzing": "Kuongorora mafambiro eutano hwako...",
      "cta": "Ona Ruzivo rweUtano Hwangu"
    },
    "toast": {
      "savedFull": "Kuongorora kuchengetedzwa! Peeji rako reutano ragadziriswa.",
      "savedShort": "Kuongorora kuchengetedzwa."
    }
  },
  "onboarding": {
    "welcome": "Mauya",
    "completeSetup": "Pedzisa Kugadzira",
    "stepProgress": "Nhanho {{step}} pa {{total}}",
    "percentComplete": "{{percent}}% zvapedzwa",
    "welcomeToast": "Mauya ku HealthLoop! Zvakakuverenga zvagadzirwa.",
    "errorAgeRange": "Ndapota sarudza zera rako",
    "errorCountry": "Ndapota sarudza nyika yako",
    "errorGoal": "Ndapota sarudza chinangwa chako chikuru cheutano",
    "errorCuisine": "Ndapota sarudza rudzi rwekudya kana kumwe chete",
    "errorGeneric": "Kukanganisika kuitika pakugadzira. Edza zvekare.",
    "step1Title": "Mauya ku HealthLoop! 👋",
    "step1Subtitle": "Ngatigadzirei chirongwa cheutano chakakukwanira",
    "ageRangeLabel": "Uri muzera ripi?",
    "genderLabel": "Uri murume kana mukadzi (Unogona kusarudza)",
    "gender_male": "Murume",
    "gender_female": "Mukadzi",
    "gender_non-binary": "Zvimwe",
    "gender_prefer_not_to_say": "Ndingada kusataura",
    "step2Title": "Unogara kupi? 🌍",
    "step2Subtitle": "Izvi zvinotibatsira kukupa zano rezvekudya zvinowanikwa kwauri",
    "countryLabel": "Sarudza nyika yako",
    "country_uk": "United Kingdom",
    "country_nigeria": "Nigeria",
    "country_ghana": "Ghana",
    "country_kenya": "Kenya",
    "country_south_africa": "South Africa",
    "country_usa": "United States",
    "country_canada": "Canada",
    "country_india": "India",
    "country_jamaica": "Jamaica",
    "country_other": "Imwe",
    "step3Title": "Chinangwa chako chikuru chii? 🎯",
    "step3Subtitle": "Sarudza zvaunoda kuzadzisa pautano hwako",
    "additionalGoals": "Zvimwe zvinangwa? (Optional)",
    "goal_weight_loss": "Kuderedza muviri",
    "goalDesc_weight_loss": "Deredza huremu nenzira ine utano",
    "goal_weight_maintenance": "Kuchengetedza huremu",
    "goalDesc_weight_maintenance": "Ramba uri pahuremu hwauri parizvino",
    "goal_muscle_gain": "Kuvaka mhasuru",
    "goalDesc_muscle_gain": "Gadzira simba nemhasuru",
    "goal_general_wellness": "Utano huzere",
    "goalDesc_general_wellness": "Kugadzirisa utano hwako hwose",
    "goal_better_sleep": "Kurara zvakanaka",
    "goalDesc_better_sleep": "Gadzirisa kurara kwako",
    "goal_reduce_stress": "Kuderedza kuremerwa nepfungwa",
    "goalDesc_reduce_stress": "Bata nekumanikidzwa kwepfungwa zviri nani",
    "goal_increase_energy": "Simba remuviri",
    "goalDesc_increase_energy": "Inzwa uine simba rakawanda",
    "step4Title": "Zvekudya zvaunofarira 🍽️",
    "step4Subtitle": "Sarudza mhando dzekudya dzaunoda nezvinhu zvausingadyi",
    "cuisineLabel": "Mhando dzekudya dzaunoda",
    "cuisineHint": "Sarudza kana imwe chete (unogona kusarudza dzakawanda)",
    "dietaryLabel": "Zvausingadyi (Optional)",
    "diet_vegetarian": "Miriwo chete",
    "diet_vegan": "Miriwo yega yega (Vegan)",
    "diet_halal": "Halal",
    "diet_kosher": "Kosher",
    "diet_gluten_free": "Zvisina Gluten",
    "diet_dairy_free": "Zvisina mukaka",
    "diet_pescatarian": "Miriwo nehove chete",
    "step5Title": "Utano hwenyu 🏥",
    "step5Subtitle": "Optional — zvinotibatsira kukupa mazano ari nani",
    "conditionsLabel": "Une chimwe chezvinhu izvi here?",
    "conditionsHint": "Ruzivo urwu nderwenyu mega uye runotibatsira kukubatsirai",
    "condition_diabetes": "Chirwere cheshuga",
    "condition_hypertension": "BP (Hypertension)",
    "condition_heart_disease": "Chirwere chemoyo",
    "condition_thyroid": "Dambudziko reThyroid",
    "condition_celiac": "Chirwere cheCeliac",
    "condition_ibs": "IBS",
    "condition_none": "Hapana",
    "privacyTitle": "Ruzivo rwako rwakadzivirirwa",
    "privacyBody": "Ruzivo rwako rwakavharirwa uye rwakachengetedzwa zvakanaka. Tinoshandisa ruzivo urwu chete kukupa mazano ekudya akakukwanira, mazano eutano, uye zviyeuchidzo. Mashoko ako haazombopiwi kune vamwe pasina mvumo yako.",
    "trackMedication": "Ndinoda kunyora mishonga yandiri kumwa",
    "specialistInterest": "Ndinoda kubatsirwa nenyanzvi dzeutano",
    "welcomeTitle": "Tikugashirei kuHealthLoop! 👋",
    "welcomeSubtitle": "Ngatigadzirise ruzivo rwenyu rwehutano hwekuzvidzivirira nekurarama zvakanaka nematanho mashoma ari nyore",
    "stepLabel": "Danho {{current}} pa {{total}}",
    "skipForNow": "Svetuka parizvino",
    "skipToast": "Munogona kupedzisa kugadzira nhoroondo yenyu chero nguva paprofile yenyu",
    "back": "Dzoka shure",
    "next": "Mberi",
    "completing": "Zvave kupedziswa...",
    "complete": "Pedzisa Kugadzira",
    "successToast": "Tikugashirei kuHealthLoop! Nhoroondo yenyu yagadziriswa zvinoenderana nemi 🎉",
    "failureToast": "Kugadzira nhoroondo kwakundikana",
    "validation": {
      "basicInfo": "Ndapota zadzisai zvese zvinodiwa",
      "pickGoal": "Ndapota sarudzai chinangwa chehutano chimwe chete",
      "pickPrimary": "Ndapota sarudzai chinangwa chenyu chikuru",
      "pickRegion": "Ndapota sarudzai dunhu retsika dzenyu kuti tiwane mazano ezvekudya",
      "pickFocus": "Ndapota sarudzai pfungwa yenyu huru yehutano"
    },
    "step1": {
      "title": "Nhoroondo Yeutano Yenyu",
      "description": "Tibatsirei kugadzira ruzivo rwehutano rwakanyatsogadzirirwa imi",
      "age": "Zera *",
      "agePlaceholder": "saka, 30",
      "height": "Kureba (cm) *",
      "heightPlaceholder": "saka, 170",
      "weight": "Huremu (kg) *",
      "weightPlaceholder": "saka, 70"
    },
    "step2": {
      "title": "Zvinangwa Zvenyu Zvehutano",
      "description": "Sarudzai zvese zvinoshanda kwauri, wobva wasarudza chinangwa chako chikuru",
      "primaryLabel": "Sarudzai Chinangwa Chako Chikuru *",
      "primaryBadge": "Chikurusa"
    },
    "step3": {
      "title": "🌍 Tsika neZvekudya",
      "description": "Tibatsirei kuti tikupei mazano ezvekudya akakunakira",
      "regionLabel": "Dunhu reTsika *",
      "regionHint": "Sarudzai kwamakabva kuti tiwane mazano ezvekudya zvinoenderana nemi",
      "countryLabel": "Nyika (Optional)",
      "countryPlaceholder": "saka, Nigeria, Kenya, Jamaica",
      "countryHint": "Kuti tiwane mazano akanyatsodzika",
      "foodPrefLabel": "Sarudzo dzeMhando dzeZvekudya"
    },
    "step4": {
      "title": "Pfungwa Huru Yehutano",
      "description": "Sarudzai chikamu chamunoda kunyanya kuisa pfungwa kwacho"
    },
    "step5": {
      "title": "Zvido Zvenyu",
      "description": "Gadzirisai mashandiro eHealthLoop zvinoenderana nemi",
      "trackMeds": "Tevedza Mishonga",
      "trackMedsHint": "Gonesa kuyeuchidzwa kwemishonga mukuongorora kwenyu kwezuva nezuva",
      "specialist": "Kuda Rubatsiro rweNyanzvi",
      "specialistHint": "Wana rubatsiro rwenyanzvi dzehutano, nyanzvi dzekudya, nevanobatsira mupfungwa",
      "confidentialTitle": "Rubatsiro rwakavandika:",
      "confidentialBody": "Ruzivo rwenyu rwese rwakachengetedzwa uye runoshandiswa chete kukupai mazano ehutano ekuzvidzivirira."
    },
    "step6": {
      "title": "Kugadzirisa Zvekudya",
      "description": "Tibatsirei kukupai mazano ezvekudya zvinoenderana nezvamunofarira",
      "cuisinesLabel": "Mhando dzeZvekudya (Optional)",
      "cuisinesHint": "Sarudzai zvekudya zvamunofarira zvakanyanya",
      "dietaryLabel": "Zvekudya Zvamusingadi (Optional)",
      "dietaryHint": "Sarudzai zvese zvinoshanda kwamuri",
      "allergiesLabel": "Zvinhu Zvinokukanganisai (Optional)",
      "allergiesHint": "Sarudzai zvekudya zvinokupai miviri kana kusagadzikana",
      "personalisedTitle": "Zvekudya Zvenyu:",
      "personalisedBody": "Tichashandisa izvi kukupai mazano ezvekudya zvinoenderana nekuravira kwenyu. Munogona kuzvichinja chero nguva muSettings."
    },
    "healthGoals": {
      "better_sleep": "Kurara Zvakanaka",
      "reduce_stress": "Kuderedza Kufungisisa",
      "increase_energy": "Kuwedzera Simba",
      "weight_management": "Kugadzirisa Huremu",
      "improve_fitness": "Kusimbisa muViri",
      "better_nutrition": "Kudya Zvakanaka",
      "mental_wellness": "Utano hwePfungwa",
      "chronic_condition": "Kutarisira Utano"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "Utano hwePfungwa",
        "description": "Kutarisa manzwiro, kufungisisa, nepfungwa dzakasununguka"
      },
      "physical_fitness": {
        "label": "Kusimba muViri",
        "description": "Kutarisa kurovedza muviri nekushanda kwemuviri"
      },
      "nutrition": {
        "label": "Kudya Kwakanaka",
        "description": "Kutarisa mhando dzezvekudya nekudya zvine utano"
      },
      "sleep": {
        "label": "Kurara Zvakanaka",
        "description": "Kutarisa kuzorora, kurara, nekuzvivandudza"
      },
      "stress_management": {
        "label": "Kuderedza Stress",
        "description": "Kutarisa kuzorora nekuva nemufaro"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "West African",
        "description": "Zvekudya zvekuNigeria, Ghana, neSenegal"
      },
      "east_african": {
        "label": "East African",
        "description": "Zvekudya zvekuKenya, Ethiopia, neTanzania"
      },
      "north_african": {
        "label": "North African",
        "description": "Zvekudya zvekuMorocco neEgypt"
      },
      "southern_african": {
        "label": "Southern African",
        "description": "Zvekudya zvekuSouthern Africa"
      },
      "caribbean": {
        "label": "Caribbean",
        "description": "Zvekudya zvekuJamaica, Trinidad, neBarbados"
      },
      "middle_eastern": {
        "label": "Middle Eastern",
        "description": "Zvekudya zvekuLebanon, Palestine, neSyria"
      },
      "south_asian": {
        "label": "South Asian",
        "description": "Zvekudya zvekuIndia, Pakistan, neBangladesh"
      },
      "east_asian": {
        "label": "East Asian",
        "description": "Zvekudya zvekuChina, Japan, neKorea"
      },
      "southeast_asian": {
        "label": "Southeast Asian",
        "description": "Zvekudya zvekuThailand, Vietnam, neIndonesia"
      },
      "western": {
        "label": "Western",
        "description": "Zvekudya zvekuAmerica neEurope"
      },
      "latin_american": {
        "label": "Latin American",
        "description": "Zvekudya zvekuMexico, Brazil, neArgentina"
      },
      "mediterranean": {
        "label": "Mediterranean",
        "description": "Zvekudya zvekuGreece, Italy, neSpain"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "Zvechinyakare",
        "description": "Zvekudya zvizhinji zvemutsika yenyu"
      },
      "mixed": {
        "label": "Zvakavhenganiswa",
        "description": "Kudya kwemuno nekune dzimwe nyika"
      },
      "international": {
        "label": "Zvepasirese",
        "description": "Zvekudya zvakasiyana-siyana zvepasi rose"
      }
    },
    "cuisines": {
      "west_african": "West African",
      "caribbean": "Caribbean",
      "mediterranean": "Mediterranean",
      "asian": "Asian",
      "western": "Western",
      "indian": "Indian",
      "middle_eastern": "Middle Eastern",
      "general": "Zvekudya Zvese"
    },
    "dietary": {
      "vegetarian": "Zvinomera Chete",
      "vegan": "Vegan",
      "pescatarian": "Zvinomera neHove",
      "gluten_free": "Pasina Gluten",
      "dairy_free": "Pasina Meleki",
      "low_carb": "Low-Carb"
    },
    "allergies": {
      "nuts": "Nzungu",
      "shellfish": "Zvisikwa zvemuGungwa",
      "dairy": "Meleki",
      "eggs": "Mazai",
      "soy": "Soya",
      "gluten": "Gluten"
    },
    "cuisine_nigerian": "chiNaijeriya",
    "cuisine_ghanaian": "chiGana",
    "cuisine_senegalese": "chiSenegari",
    "cuisine_kenyan": "chiKenya",
    "cuisine_ethiopian": "chiEtiopiya",
    "cuisine_moroccan": "chiMoroko",
    "cuisine_south_african": "chiSouth Africa",
    "cuisine_jamaican": "chiJamaika",
    "cuisine_trinidadian": "chiTrinidad",
    "cuisine_lebanese": "chiLebhanoni",
    "cuisine_turkish": "chiTeki",
    "cuisine_greek": "chiGiriki",
    "cuisine_italian": "chiItari",
    "cuisine_french": "chiFurenchi",
    "cuisine_british": "chiBhuritishi",
    "cuisine_indian_south": "chiIdiya chekuChamhembe",
    "cuisine_indian_north": "chiIdiya chekuMuzinda",
    "cuisine_pakistani": "chiPakistani",
    "cuisine_japanese": "chiJapani",
    "cuisine_chinese": "chiChainizi",
    "cuisine_korean": "chiKoriya",
    "cuisine_vietnamese": "chiVietnam",
    "cuisine_thai": "chiThai",
    "cuisine_filipino": "chiFilipino",
    "cuisine_american": "chiAmerika",
    "cuisine_mexican": "chiMekisiko",
    "cuisine_brazilian": "chiBhuraziri",
    "cuisine_peruvian": "chiPeru"
  },
  "dashboard": {
    "welcome": "Mauya zvekare",
    "greeting": "Mhoroi",
    "goodMorning": "Mangwanani",
    "goodAfternoon": "Masikati",
    "goodEvening": "Manheru",
    "tagline": "Nhanho diki dzeutano dzinounza shanduko inogara",
    "microcopy": "Utano hwako hwakakosha.",
    "welcomeSubtitleMorning1": "Kutanga zuva rine runyararo.",
    "welcomeSubtitleMorning2": "Tafara kuti mavatoshanya muno mangwanani ano.",
    "welcomeSubtitleMorning3": "Zvidiki zvaunoita zvinovaka utano.",
    "welcomeSubtitleAfternoon1": "Ndinovimba zuva riri kufamba zvakanaka.",
    "welcomeSubtitleAfternoon2": "Mauya zvekare ku HealthLoop.",
    "welcomeSubtitleAfternoon3": "Fema zvakanaka — urikuita basa rakanaka.",
    "welcomeSubtitleEvening1": "Kuzorora pamwe chete nemi.",
    "welcomeSubtitleEvening2": "Kupedza zuva zvinyoro nyoro.",
    "welcomeSubtitleEvening3": "Mauya zvekare manheru ano.",
    "title": "Chirongwa Chenyu Chekudzivirira Utano",
    "subtitle": "Ongorora, dzidza, uye tora matanho matambudziko asati akura",
    "summary": "Pfupiso yeUtano Hwako",
    "summaryDesc": "Ruzivo rwazvino rwekudzivirira, dzidzo, uye utano hwakanaka",
    "comprehensiveSupport": "Rubatsiro rwakakwana pakudzivirira, dzidzo, uye utano",
    "todayCheckIn": "Kuongorora Utano Kwaro nhasi",
    "quickActions": "Zvekuita Nechimbichimbi",
    "healthOverview": "Utano Hwakazara",
    "recentActivity": "Zvichangobva Kuitwa",
    "viewAll": "Wona Zvese",
    "preventiveHealth": "Kudzivirira Utano",
    "preventiveHealthDesc": "Kuongorora kwaro nhasi, utano, uye yambiro dzekudzivirira",
    "education": "Dzidzo",
    "educationDesc": "Ruzivo rwechokwadi, zvinyorwa zveutano nemazano enyanzvi",
    "engagement": "Kudyidzana",
    "engagementDesc": "Makwikwi, kuongorora zvaunogara uchiita, nerubatsiro",
    "wellness": "Utano Hwakanaka",
    "wellnessDesc": "Kudya nehungwaru nemararamiro akachengeteka",
    "todaysInsight": "Zano ranhasi",
    "wellnessScore": "Chibodzwa cheUtano",
    "healthStreak": "Kuteedzera Utano",
    "days": "mazuva",
    "logHealth": "Nyora zveUtano",
    "getEducated": "Dzidza",
    "communityChallenge": "Zvekuita neNharaunda",
    "checkWellness": "Tarisa Utano",
    "verified": "Zvakasimbiswa",
    "joinCommunity": "Pinda muNharaunda",
    "personalizedPlan": "Chirongwa Chako",
    "score": "Chibodzwa",
    "checkIns": "kuongorora",
    "habits": "maitiro",
    "preventive": "Kudzivirira",
    "healthMetrics": "Zviyero zveUtano",
    "trackMetrics": "Ongorora Zviyero",
    "startTracking": "Tanga kuongorora",
    "logMetrics": "Nyora Zviyero",
    "dailyInsight": "Zano reZuva",
    "learnAbout": "Dzidza nezvekudzivirira zvirwere nhasi",
    "articlesAvailable": "zvinyorwa zviripo",
    "browseArticles": "Verenga Zvinyorwa",
    "currentStreak": "Kuteedzera Kwazvino",
    "keepGoing": "Ramba uchidaro!",
    "startStreak": "Tanga kuteedzera",
    "checkIn": "Kuongorora Utano",
    "nutritionPlan": "Chirongwa cheKudya",
    "mealsPlanned": "zvekudya zvakarongwa",
    "viewPlan": "Wona Chirongwa",
    "planYourWeek": "Ronga vhiki yako",
    "moodStress": "Manzwiro & Kuremerwa",
    "howFeeling": "Urikunzwa sei?",
    "logWellness": "Nyora zveUtano",
    "medications": "Mishonga",
    "noMeds": "Hapana mishonga iri kunyorwa",
    "addMedications": "Wedzera mishonga yako",
    "daysTracked": "Mazuva Akatariswa",
    "noHabits": "Hapana maitiro anyorwa",
    "startTrackingHabits": "Tanga kunyora maitiro",
    "insights": "Ruzivo",
    "noInsights": "Hapana ruzivo parizvino",
    "completeFirstPlan": "Pedzisa chirongwa chako chekutanga",
    "noCheckIns": "Hapana kuongorora kwaitwa",
    "startFirstCheckIn": "Tanga kuongorora kwako kwekutanga"
  },
  "support": {
    "title": "Rubatsiro",
    "subtitle": "Tsvaga mhinduro, taura nesu, kana kutaura dambudziko",
    "backToSettings": "Dzokera kugadziriro",
    "privacyBanner": "Zvikumbiro zverubatsiro zvinobatwa zvakavandika. Utano hwenyu hucharamba huri pakati pedu.",
    "section1": "Chikamu 1",
    "section2": "Chikamu 2",
    "section3": "Chikamu 3",
    "section4": "Chikamu 4",
    "navHelpCenter": "Nzvimbo yeRubatsiro",
    "navContact": "Taura neSupport",
    "navHealth": "Zveutano",
    "navTechnical": "Zvehunyanzvi",
    "helpCenterTitle": "Nzvimbo yeRubatsiro",
    "helpCenterSubtitle": "Tsvaga mibvunzo inowanzo bvunzwa.",
    "contactTitle": "Taura neSupport",
    "contactSubtitle": "Taura nevedu nenzira yaunoda.",
    "healthServicesTitle": "Zveutano",
    "healthServicesSubtitle": "Batanidza nekuteedzera mishonga nenyanzvi dzeutano.",
    "technicalTitle": "Zvehunyanzvi",
    "technicalSubtitle": "Taura zviri kukanganisika muapp nemashoko akakwana.",
    "searchPlaceholder": "Tsvaga mibvunzo...",
    "liveChat": "Kukurukura Kuripo",
    "emailUs": "Titumirei Email",
    "callBack": "Kumbira kufonerwa",
    "sendMessage": "Tumira shoko",
    "medicationTracking": "Kuteedzera mishonga",
    "specialistAccess": "Kuwana nyanzvi",
    "videoConsultation": "Kutaura nenyanzvi muvhidhiyo",
    "reportBug": "Mota dambudziko reapp",
    "yourName": "Zita renyu",
    "yourEmail": "Email yenyu",
    "subject": "Musoro weShoko",
    "message": "Shoko",
    "phone": "Runhare",
    "description": "Tsananguro",
    "submit": "Tumira",
    "successTitle": "Shoko ratumirwa",
    "successDescription": "Tichakupindurai mukati memaawa 24–48.",
    "healthDisclaimer": "Kune zvipatara zvekukurumidza, fonera ve emergency vemunharaunda yenyu. HealthLoop haitsive chiremba wenyu."
  },
  "nutrition": {
    "smartNutrition": "Kudya neHungwaru",
    "basedOnGoal": "Maererano nechinangwa chako:",
    "personalizedData": "Zvakagadzirirwa iwe maererano neutano hwako",
    "evidenceBased": "Mazano ekudya akasimbiswa sechikamu chekudzivirira chirwere",
    "todaysMealSuggestions": "Zvekudya zvanhasi",
    "customize": "Gadzirisa",
    "breakfast": "Chisvusvuro",
    "lunch": "Kudya kwemasikati",
    "dinner": "Kudya kwemanheru",
    "loadingBreakfast": "Chisvusvuro chiri kutakura...",
    "loadingLunch": "Zvemasikati zviri kutakura...",
    "loadingDinner": "Zvemanheru zviri kutakura...",
    "cal": "cal",
    "protein": "protein",
    "swapMeal": "Chinja Kudya",
    "healthyOptionsNearYou": "Zvekudya zvine utano pedyo newe",
    "enableLocation": "Vhurai nzvimbo (location)",
    "view": "Wona",
    "discoverOptions": "Tsvaga maresitarendi, zvitoro, nevatengesi vezvekudya zvine utano pedyo newe",
    "cuisinesSelected": "mhando dzekudya dzakasarudzwa",
    "cuisineSelected": "mhando yekudya yakasarudzwa",
    "dietaryPrefs": "zvamunoda kudyidzana nazvo",
    "dietaryPref": "zvamunoda kudya",
    "customizeMeals": "Gadzirisa Zvekudya",
    "subtitleAdaptive": "Kurongwa kwezvekudya zvine utano kunoenderana netsika yako nezvinangwa zvako",
    "hideFavorites": "Viga Zvaunofarira",
    "viewFavorites": "Wona Zvaunofarira",
    "customizeMealsLegacy": "Gadzirisa zvekudya kuti zvienderane netsika yako nezvaunodya",
    "viewFullPlan": "Wona Chirongwa Chose",
    "exploreRecipes": "Tsvaga Mabikirwo"
  },
  "location": {
    "permissionTitle": "Tsvaga zvekudya zvine utano pedyo newe",
    "permissionDesc": "Inoshandiswa kukupa mazano emaresitarendi nevatengesi vezvekudya zvinoenderana neutano hwako.",
    "howToEnable": "Kuvhura seiko:",
    "step1": "Dzvanya pakiinji ye lock 🔒 mubhurausa yako",
    "step2": "Tsvaga \"Location\" permissions",
    "step3": "Chinja kuenda pa \"Allow\"",
    "step4": "Zorodza (refresh) peji rino",
    "refreshPage": "Zorodza Peji",
    "allowLocation": "Bvumira Nzvimbo",
    "notNow": "Kwete iye zvino",
    "denied": "Kushandisa nzvimbo kwakavharwa. Kuti uone zvekudya pedyo newe, unofanira kubvumira nzvimbo.",
    "unavailable": "Ruzivo rwenharaunda harusi kuwanikwa parizvino. Tarisai zvirongwa zvefoni yenyu.",
    "error": "Takatadza kuwana kwauri. Edzai zvekare kana kutarisa zvirongwa zvebhurausa.",
    "unsupported": "Bhurausa yako haikwanisi kukuudza kwauri. Edza kushandisa itsva se Chrome, Firefox, kana Safari.",
    "accessRequired": "Mvumo yeNzvimbo Inodiwa"
  },
  "womensHealth": {
    "title": "Utano hweVadzimai",
    "description": "Kuteedzera kutevera kwenyu, kunyora manzwiro emuviri, uye kuwana mazano eutano",
    "cycleTracking": "Kuteedzera Kutevera",
    "symptomLogging": "Kunyora Zviratidzo",
    "phaseInsights": "Ruzivo rweCycle",
    "logPeriod": "Nyora zveKutevera",
    "logSymptoms": "Nyora Zviratidzo",
    "insights": "Ruzivo",
    "tips": "Mazano eUtano",
    "overview": "Pfupiso",
    "history": "Zvakaitika Kare",
    "startTracking": "Tanga Kuteedzera Kutevera Kwako"
  },
  "profile": {
    "title": "Zvakakuverenga",
    "personalInfo": "Ruzivo Rwenyu",
    "healthProfile": "Utano Hwenyu",
    "preferences": "Zvamunosarudza",
    "language": "Mutauro",
    "selectLanguage": "Sarudza Mutauro",
    "notifications": "Zviziviso",
    "privacy": "Rugare rweRuzivo",
    "security": "Dziviriro",
    "quickAccess": "Kuwana nekukurumidza",
    "editProfile": "Gadzirisa Zvakakuverenga",
    "viewStats": "Wona nhamba",
    "backToDashboard": "Dzokera Pamba",
    "womensHealthTitle": "Utano hweVadzimai",
    "womensHealthDesc": "Kuteedzera kutevera, zviratidzo nemazano",
    "healthRemindersTitle": "Zviyeuchidzo zveUtano",
    "healthRemindersDesc": "Ronga zviziviso zvako",
    "manageRemindersDesc": "Ronga mashandiro ezviyeuchidzo nezviziviso",
    "healthPatternAlerts": "Yambiro dzeUtano Hwako",
    "supportHelp": "Rubatsiro",
    "supportHelpDesc": "Wana rubatsiro kana kutarisa mibvunzo",
    "admin": "Mubati",
    "adminDesc": "Wona mashandiro eapp",
    "giveFeedback": "Pa Maonero",
    "giveFeedbackDesc": "Tiudze maonero ako ne HealthLoop",
    "reportProblem": "Mota Dambudziko",
    "reportProblemDesc": "Tibatsire kugadzirisa zvisiri kushanda",
    "manageHealthInfo": "Ronga ruzivo rwako rwekudzivirira utano kuti uwane mazano akakukwanira",
    "basicInformation": "Ruzivo rweKutanga",
    "fullName": "Zita Rakazara",
    "email": "Email",
    "dateOfBirth": "Zuva reKuzvarwa",
    "gender": "Murume/Mukadzi",
    "height": "Kureba (cm)",
    "weight": "Huremu (kg)",
    "medicalConditions": "Zvirwere zviripo",
    "allergies": "Zvinokukanganisa (Allergies)",
    "personalHealth": "Utano hweMunhu",
    "addCondition": "Wedzera dambudziko reutano",
    "addAllergy": "Wedzera dambudziko rekusamwa/kudyidzana nechimwe chinhu",
    "saveChanges": "Chengetedza Shanduko",
    "saving": "Zvichichengetedzwa...",
    "privacyMessage": "Ruzivo rwenyu rweutano rwakachengetedzwa zvakavandika"
  },
  "settings": {
    "title": "Zvigadziriso",
    "general": "Zvose",
    "account": "Akaundi",
    "appearance": "Chitarisiko",
    "languageSettings": "Zvigadziriso zveMutauro",
    "changeLanguage": "Chinja Mutauro",
    "languageNote": "Zvinoshanduka pakubva wangosarudza mutauro mutsva. Mitauro yemuAfrica nemitsva yakanyorwa kuti Starter — yakashandurwa nemushini kuti ikasike kuwanikwa, ichimirira kuongororwa nenyanzvi dzemutauro.",
    "languageUpdated": "Mutauro wagadziriswa zvinobudirira",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "Yakashandurwa nemushini — kumirira kuongororwa nenyanzvi yemutauro.",
    "regions": {
      "global": "Pasi rose",
      "european": "Mitauro yeEurope",
      "middleEastern": "Mitauro yeMiddle East",
      "asian": "Mitauro yeAsia",
      "african": "Mitauro yeAfrica"
    }
  },
  "search": {
    "triggerLabel": "Tsvaga muHealthLoop",
    "triggerHint": "Edza \"nhanho\", \"famasii\" kana \"nhumbu\"",
    "triggerAriaLabel": "Vhurai kotsvaga kwese",
    "placeholder": "Tsvaga zvirongwa, rutsigiro…",
    "inputAriaLabel": "Tsvaga zvirongwa zveHealthLoop",
    "modalAriaLabel": "Tsvaga muHealthLoop",
    "close": "Vhara",
    "clear": "Dzima",
    "clearAriaLabel": "Dzima zvanyorwa",
    "recentSearches": "Zvauchangobva kutsvaga",
    "tryFor": "Edza kutsvaga",
    "findFeatures": "Wana chero chirongwa nekuchimbidza.",
    "searchAcross": "Tsvaga mu",
    "and": "uye",
    "sections": {
      "home": "Kumba",
      "nutrition": "Zvekudya",
      "family": "Mhuri",
      "services": "Mabasa",
      "support": "Rutsigiro",
      "profile": "Purofairu"
    },
    "noMatchesFor": "Hapana zvawanikwa pa \"{{query}}\"",
    "trySimpler": "Edza kushandisa mazwi akareruka senge nhanho, zvekudya kana chiremba.",
    "comingSoonBadge": "Zviri kuuya munguva pfupi",
    "escToClose": "kuti uvhare",
    "resultSingular": "{{count}} chawanikwa",
    "resultPlural": "{{count}} zvawanikwa",
    "searchAcrossApp": "Tsvaga muapp yese"
  },
  "familyMember": {
    "confirmRemove": "Bvisa {{name}} kubva pakutarira hutano hwemhuri?",
    "removed": "{{name}} abviswa mumhuri",
    "removeFailed": "Kukundikana kubvisa nhengo",
    "viewDetails": "Wona zvizere",
    "edit": "Gadzirisa",
    "remove": "Bvisa",
    "yearsSuffix": "makore",
    "healthGoalsLabel": "Zvinangwa zvehutano:",
    "moreSuffix": "zvimwe",
    "activeInsights": "Mazano aripo",
    "viewAllInsights": "Wona mazano ese {{count}} →",
    "viewFullProfile": "Wona Purofairu yeHutano Zvizere",
    "lifeStage": {
      "infant": "Mucheche (0-2)",
      "toddler": "Mwana mudiki (2-5)",
      "child": "Mwana (6-12)",
      "adolescent": "Pwere (13-17)",
      "adult": "Munhu mukuru (18-59)",
      "senior": "Harahwa/Chembere (60+)",
      "unknown": "Hazvizivikanwi"
    }
  },
  "profileDeep": {
    "backToDashboard": "Dzokera pekutanga",
    "profileCompletion": "Kuzara kwePurofairu",
    "healthSummary": "Muchidimbu nezveutano",
    "sectionA": "Chikamu A",
    "sectionB": "Chikamu B",
    "sectionC": "Chikamu C",
    "sectionD": "Chikamu D",
    "personalDetails": "Zviziviso zvako",
    "healthInformation": "Mashoko eutano",
    "accountSettings": "Zvigadziriso zveakaundi",
    "fullName": "Zita rakazara",
    "email": "Imeyiri",
    "dob": "Zuva rekuzvarwa",
    "gender": "Chirume kana Chikadzi",
    "genderPlaceholder": "saka: Mukadzi, Murume, kana zvimwe",
    "height": "Kureba (cm)",
    "heightPlaceholder": "saka: 170",
    "weight": "Huremu (kg)",
    "weightPlaceholder": "saka: 70",
    "allergies": "Zvinokukanganisa (Allergies)",
    "allergiesPlaceholder": "saka: Nzungu",
    "medicalConditions": "Zvirwere zvaunozivikanwa unazvo",
    "conditionsPlaceholder": "saka: BP yepamusoro",
    "medications": "Mishonga yaunomwa",
    "medicationsPlaceholder": "saka: Lisinopril 10mg, zuva nezuva",
    "emergencyContact": "Munhu anobatsira pakaipa",
    "emergencyOptional": "(kana uchida)",
    "emergencyPlaceholder": "saka: Amai +1-555-0100",
    "emergencyNote": "Zvinongoonekwa chete nanachiremba kana iwe ukabvuma.",
    "saveChanges": "Chengetedza zvachinjwa",
    "saving": "Zviri kuchengetedzwa...",
    "editProfile": "Gadzirisa purofairu",
    "cancelEditing": "Misa kugadzirisa",
    "healthScore": "Zvibodzwa zveutano",
    "streak": "Mazuva akatevedzana",
    "streakDays": "Mazuva {{n}}",
    "memberSince": "Nhengo kubva",
    "remindersActive": "Zviyeuchidzo zviri kushanda",
    "conditionsTracked": "Zvirwere zviri kutariswa",
    "nextAgenda": "Zvinotevera parongwa rwako",
    "notificationsReminders": "Zviziviso nezviyeuchidzo",
    "notificationsRemindersDesc": "Gadzirisa nguva nenzira dzezviyeuchidzo zveutano",
    "emailNudges": "Zviyeuchidzo zvepaImeyiri",
    "emailNudgesDesc": "Zviyeuchidzo zvinyoro nepfupiso dzevhiki",
    "on": "Zvakabatidzwa",
    "paused": "Zvimbomiswa",
    "privacySecurity": "Kuvanzika nekuchengetedzeka",
    "privacySecurityDesc": "Chinja password yako kuti akaundi igare yakachengetedzeka",
    "preferencesTitle": "Zvaunosarudza",
    "preferencesDesc": "Mutauro, nzvimbo, nezvako pachako",
    "supportHelp": "Ruyamuro nerubatsiro",
    "supportHelpDesc": "Wana mhinduro uye taura nesu",
    "giveFeedback": "Taura zvaunofunga",
    "giveFeedbackDesc": "Tiudze zvatinofanira kugadzirisa",
    "reportProblem": "Taura dambudziko",
    "reportProblemDesc": "Wawana chinokanganisa here? Tizivise",
    "adminInsights": "Zvinotariswa nevatungamiri",
    "adminInsightsDesc": "Kuongorora mashandisirwo echirongwa",
    "adminBadge": "Mutungamiri",
    "shareWithClinician": "Govana nanachiremba",
    "shareWithClinicianDesc": "Muchidimbu chekuverenga chete · chinopera choga · unogona kuchimisa chero nguva",
    "share": "Govana",
    "profileMayBeOutOfDate": "Purofairu yako inogona kunge isina kuitwa itsva",
    "profileMayBeOutOfDateDesc": "Chengetedza mashoko ako eutano ari pachokwadi kuti uwane mazano akakodzera — kunyangwe shanduko diki (huremu, mishonga) dzinotibatsira kukupa zviyeuchidzo zvakakufanira.",
    "updateNow": "Gadzirisa iye zvino",
    "profileUpdateError": "Tatsatadza kugadzirisa zvausarudza. Tapota edza zvakare.",
    "healthLoopUser": "Mushandisi weHealthLoop",
    "updatedLabel": "Zvaitwa zvitsva",
    "noEntries": "Hapasati pava nezvanyorwa.",
    "completionComplete": "Purofairu yako yakazara. Iye zvino tinokwanisa kukupa mazano akanaka kwazvo. 💚",
    "completionAlmostThere": "Wasara zvishoma. Mashoko mashoma asara anozivisa mazano akadzama.",
    "completionInProgress": "Pedzisa purofairu yako kuti uwane mazano ari nani ekugara zvakanaka.",
    "justNow": "iye zvino",
    "minAgo": "mineti {{n}} yapfuura",
    "minsAgo": "mamineti {{n}} apfuura",
    "hourAgo": "awa {{n}} yapfuura",
    "hoursAgo": "maawa {{n}} apfuura",
    "dayAgo": "zuva {{n}} rapfuura",
    "daysAgo": "mazuva {{n}} apfuura",
    "checkinDueToday": "Unofanira kuzvitarisa nhasi",
    "checkinDueTonight": "Unofanira kuzvitarisa manheru ano"
  },
  "supportDeep": {
    "backToSettings": "Dzokera kuzvigadziriso",
    "quickNavAria": "Zvikamu zverubatsiro",
    "searchPlaceholder": "Tsvaga rubatsiro...",
    "searchAria": "Tsvaga mibvunzo inowanzo bvunzwa",
    "resultsCount": "mhedzisiro {{n}}",
    "resultsCountPlural": "mhedzisiro {{n}}",
    "questionsCount": "mibvunzo {{n}}",
    "liveChatTitle": "Kutaura nesu (Live Chat)",
    "liveChatDesc": "Taura nesu iye zvino · Muvhuro–Chishanu 9am–6pm",
    "startChat": "Tanga Kutaura",
    "liveChatSoonToast": "Kutaura nesu iye zvino kuchatanga munguva pfupi. Parizvino, tishandisire imeyiri.",
    "emailUsTitle": "Titumire Imeyiri",
    "emailUsDesc": "Mhinduro inouya mukati memaawa 24–48",
    "copy": "Kopa",
    "emailCopied": "Imeyiri yakopwa.",
    "contactFormTitle": "Fomu rekutaura nesu",
    "contactFormDesc": "Titumire meseji — tichakupindura neimeyiri.",
    "yourNameLabel": "Zita rako *",
    "namePlaceholder": "Zita renyu",
    "yourEmailLabel": "Imeyiri yako *",
    "emailPlaceholder": "zita@example.com",
    "subjectOptional": "Musoro wenyaya (kana uchida)",
    "subjectPlaceholder": "Tingakubatsira nei?",
    "messageLabel": "Meseji *",
    "messagePlaceholder": "Tiudze zvishoma nezvezvauri kuda.",
    "sending": "Zviri kutumirwa...",
    "sendMessage": "Tumira Meseji",
    "messageSent": "Meseji yatumirwa",
    "messageSentDesc": "Tichakupindura mukati memaawa 24–48.",
    "callbackTitle": "Kumbira kufonerwa",
    "callbackDesc": "Tichakufonera nenguva inokunakira.",
    "phoneLabel": "Nhamba yefoni *",
    "phonePlaceholder": "+263...",
    "preferredTimeLabel": "Nguva yaunoda (kana uchida)",
    "preferredTimePlaceholder": "saka: mangwana masikati",
    "reasonLabel": "Chikonzero (kana uchida)",
    "reasonPlaceholder": "Muchidimbu, unoda kuti tikurukure nezvei?",
    "submitting": "Zviri kutumirwa...",
    "requestCallback": "Kumbira Kufonerwa",
    "callbackRequested": "Kumbira kufonerwa kwaitwa",
    "callbackRequestedDesc": "Tichataura newe mukati memaawa 24.",
    "medicationSupport": "Rubatsiro rweMishonga",
    "medicationSupportDesc": "Tevedzera mishonga yako nekuyeuchidzwa.",
    "goToMedications": "Enda kumishonga →",
    "specialistConsultation": "Kutaura nenyanzvi",
    "specialistConsultationDesc": "Taura nanachiremba kuti uwane mazano eutano akakufanira.",
    "connectExpert": "Taura nenyanzvi →",
    "videoConsult": "Kutaura muvhidhiyo",
    "videoConsultDesc": "Bhuka nguva yekutaura nenyanzvi mumeso nemumeso paVhidhiyo.",
    "bookConsultation": "Bhuka nguva →",
    "premium": "Premium",
    "healthDisclaimer": "HealthLoop inobatsira pakurarama zvakanaka zuva nezuva — haitsivi kurapwa kwekukurumidza kwekuchipatara. Kana paine chakuchimbidza, tapota fonera vemayambuka (emergency services) vemunharaunda yako.",
    "categoryLabel": "Chikamu",
    "catBug": "Chikanganiso chechirongwa (Bug)",
    "catPerformance": "Chirongwa chiri kunonoka",
    "catFeature": "Chinhu chisingashande",
    "catUi": "Dambudziko rechitarisiko",
    "catOther": "Zvimwe",
    "issueTitle": "Musoro wedambudziko *",
    "issueTitlePlaceholder": "Pfupiso yezviri kuitika",
    "detailedDescription": "Tsananguro yakazara *",
    "detailedDescriptionPlaceholder": "Chii chaitika? Wanga uchiitei pazvaitika? Matanho awatora anotibatsira zvikuru.",
    "autoAttachNote": "Zviziviso zvefoni nebrowser zvinoenda zvega.",
    "submitReport": "Tumira Gwaro",
    "reportSubmitted": "Gwaro ratumirwa",
    "reportSubmittedDesc": "Chikwata chedu chiri kutorishanda.",
    "fillAllFields": "Tapota zadza nzvimbo dzose dzinodiwa",
    "problemReportSubmittedToast": "Gwaro redambudziko ratumirwa. Tichaongorora tokupindura munguva pfupi.",
    "messageSentToast": "Meseji yatumirwa. Tichakupindura mukati memaawa 24–48.",
    "callRequestedToast": "Chikumbiro chekufonerwa chagamuchirwa. Tichataura newe mukati memaawa 24.",
    "submitFailGeneric": "Kutumira kwatadza. Tapota edza zvakare kana kutumira imeyiri ku {{email}}.",
    "submitFailContact": "Kutumira kwatadza. Tapota tumira imeyiri ku {{email}} zvakananga.",
    "comingSoon": "Zvichauya munguva pfupi",
    "specialistRoadmapTitle": "Taura neNyanzvi",
    "specialistRoadmapSubtitle": "Rubatsiro rwevanhu ruri kuuya. Nzira idzi dzinenge dziri pano kuti rubatsiro ruve pedyo nemi.",
    "talkToSpecialistTitle": "Taura neNyanzvi",
    "talkToSpecialistDesc": "Kutaura iye zvino nanachiremba vane marezinesi nezve mibvunzo yeutano hwezuva nezuva.",
    "bookSpecialistTitle": "Bhuka Nyanzvi",
    "bookSpecialistDesc": "Ronga nguva yekuva nemukurukuri wenharaunda yako chaiyo.",
    "liveHealthGuidanceTitle": "Mazano eUtano ePanguva Iyo",
    "liveHealthGuidanceDesc": "Rubatsiro rwevhidhiyo rwezviratidzo zvechirwere, mhedzisiro yelab, kana hurongwa hwekurapwa.",
    "mentalWellnessTitle": "Rubatsiro rwePfungwa",
    "mentalWellnessDesc": "Rubatsiro rwakavanzika kubva kunyanzvi dzeutano hwenjere kana upenyu hwaoma.",
    "wellnessNavigationTitle": "Kutungamirirwa paUtano",
    "wellnessNavigationDesc": "Gwara rinokubatsira kusarudza danho chairo rinotevera.",
    "pharmacyRoadmapTitle": "Rubatsiro rweMishonga neFarmasi",
    "pharmacyRoadmapSubtitle": "Rubatsiro rwefarmasi runowanikwa mukati meRubatsiro — hapana tabu idzva rekudzidza.",
    "medicationGuidanceTitle": "Mazano eMishonga",
    "medicationGuidanceDesc": "Mazano ari nyore kunzwisisa pamusoro pehuwandu hwemushonga, nguva, nekudyidzana kwemishonga.",
    "findNearbyPharmacyTitle": "Tsvaga Farmasi iri Pedyo",
    "findNearbyPharmacyDesc": "Kurumidza kuwana mafarmasi akatendeka munharaunda mako kana uchida imwe mishonga.",
    "refillReminderTitle": "Rubatsiro rweKuyeuchidzwa Mishonga",
    "refillReminderDesc": "Zviyeuchidzo zvinyoro kuti usambopedzerwa nemishonga yakakosha.",
    "otcWellnessTitle": "Mazano eMishonga yePakaunita",
    "otcWellnessDesc": "Mazano akachengetedzeka pane zvaunogona kutenga pakaunita pasina tsamba yachiremba."
  },
  "careServices": {
    "pageTitle": "Mabasa eKuchengetedzwa",
    "pageSubtitle": "Rubatsiro rwekurapwa nekugara zvakanaka rwakagadzirirwa rwendo rwako rweutano hwezuva nezuva.",
    "specialistCareTitle": "Kuchengetedzwa neNyanzvi",
    "specialistCareSubtitle": "Taura nanachiremba uye bhuka nyanzvi yakakodzera paunenge uchiida.",
    "medicationPharmacyTitle": "Mishonga neFarmasi",
    "medicationPharmacySubtitle": "Mazano emishonga ari nyore kunzwisisa nerubatsiro rwefarmasi.",
    "wellnessSupportTitle": "Rubatsiro rwekugara zvakanaka",
    "wellnessSupportSubtitle": "Utano hwepfungwa, mazano emishonga yepakaunita, uye gwara rinojekesa matanho anotevera.",
    "futureWellnessTitle": "Zvichauya paUtano",
    "futureWellnessSubtitle": "Muchidimbu chezvichauya paHealthLoop kuitira kudzivirira zvirwere.",
    "futureFeatureBadge": "Zvichauya mberi",
    "futurePersonalizedMealsTitle": "Zvidyo zvakakufanira",
    "futurePersonalizedMealsDesc": "Hurongwa hwekudya hunoenderana nezvinangwa zvako, zvinokukanganisa, netsika yako.",
    "futureHealthyDeliveryTitle": "Kusvitswa kweZvidyo zvine Utano",
    "futureHealthyDeliveryDesc": "Kusvitswa kwekudya kubva kumakicheni nevanobatira pamwe vane utano.",
    "futureFarmFreshTitle": "Zvekudya zvitsva kubva kuPurazi",
    "futureFarmFreshDesc": "Kuwaniswa kwekudya kubva kumapurazi emunharaunda neshamwari dzedu dzinogadzira zvekudya zvitsva.",
    "futureFoodPartnershipsTitle": "Kudyidzana kweZvekudya zvine Utano",
    "futureFoodPartnershipsDesc": "Kushanda pamwe nemakicheni ane utano, zvitoro, nemasangano eutano.",
    "futureNutritionCoachingTitle": "Kudzidziswa Kudya Kwine Utano",
    "futureNutritionCoachingDesc": "Mazano emunhu nemunhu kubva kune vadzidzisi vezvekudya vane zvitupa.",
    "futureFamilyWellnessTitle": "Hurongwa hweUtano hweMhuri",
    "futureFamilyWellnessDesc": "Hurongwa hwekugovana hunochengetedza imba yese iine utano.",
    "futureWellnessPlusTitle": "Wellness+ Membership",
    "futureWellnessPlusDesc": "Chikamu chepamusoro chemazano akakodzera iwe pachako, rubatsiro rwekukurumidza, nekuongorora kwakadzama.",
    "futurePharmacyPartnersTitle": "Kudyidzana neMafarmasi",
    "futurePharmacyPartnersDesc": "Kudyidzana nemafarmasi akatendeka kuitira mazano emishonga nekuwedzerwa mishonga.",
    "futureAdvancedSpecialistTitle": "Kuchengetedzwa neNyanzvi dzePamusoro",
    "futureAdvancedSpecialistDesc": "Kuwaniswa kwenyanzvi nenzira yakarongeka, mazano echipiri, nekutungamirirwa pakurapwa.",
    "futureWellnessMarketplaceTitle": "Musika weUtano",
    "futureWellnessMarketplaceDesc": "Musika wakasarudzwa wezvinhu nemabasa eutano akaongororwa zvakanaka.",
    "futureVendorCollabTitle": "Hurongwa hweKushanda neVatengesi",
    "futureVendorCollabDesc": "Hurongwa hwekuunza nekuongorora unhu hwezvekudya zvine utano neshamwari dzedu dzeutano."
  },
  "dashboardDeep": {
    "healthProfile": "Purofairu yeUtano",
    "notifications": "Zviziviso",
    "familyAccounts": "Akaundi dzeMhuri",
    "settings": "Zvigadziriso",
    "logout": "Budamo",
    "allCaughtUp": "Wapedza zvose.",
    "weekInReview": "Vhiki rako muchidimbu",
    "dismissNotification": "Bvisa chiziviso",
    "dismissWeeklyDigest": "Bvisa pfupiso yevhiki",
    "notificationsAria": "Zviziviso",
    "profileMenuAria": "Vhura menyu yepurofairu",
    "loadingWellness": "Zveutano hwako zviri kuungadzwa",
    "nextTip": "Zano rinotevera",
    "todayAtGlance": "Zve nhasi muchidimbu",
    "healthScoreLabel": "Zvibodzwa zveUtano",
    "currentStreakLabel": "Mazuva Akatevedzana",
    "todaysProgress": "Zvaitwa nhasi",
    "insightForYou": "Zano rako",
    "checkMyHealthRisk": "Tarisa Njodzi yeUtano Hwangu",
    "quickAccess": "Kusvika nekukurumidza",
    "exploreCareServicesTitle": "Tsvaga Mabasa eKuchengetedzwa",
    "exploreCareServicesSubtitle": "Kuchengetedzwa neNyanzvi · farmasi · utano — zvose munzvimbo imwe.",
    "familyCare": "Kuchengetwa kweMhuri",
    "healthLibrary": "Raibhurari yeUtano",
    "myHealthData": "Mashoko Angu eUtano",
    "askQuestion": "Bvunza Mubvunzo",
    "dashLoadError": "Tatsatadza kuvhura dashboard yako. Tapota edza zvakare.",
    "taskUpdateError": "Tatsatadza kugadzirisa basa. Tapota edza zvakare.",
    "perfectDay": "Zuva ranhasi racho! 🎉 mazuva akatevedzana awedzera.",
    "letsStart": "Ngatitangei",
    "yourNextStepToday": "Danho rako rinotevera nhasi",
    "completeDailyCheck": "Pedzisa kuzvitarisa utano kwezuva nezuva",
    "startDailyCheck": "Tanga Kuzvitarisa",
    "viewAll": "Ona zvose",
    "graceProtected": "Mazuva akatevedzana achengetedzwa",
    "todaysHealthRecommendations": "Zvinokurudzirwa paUtano Nhasi",
    "updateViaCheck": "Gadzirisa pakuzvitarisa kwezuva nezuva",
    "healthInsight": "Ruzivo rweUtano",
    "riskCheckSubtext": "Wana mazano eutano akakufanira munguva pfupi",
    "foodDiet": "Zvekudya neKudya kwakakodzera",
    "healthScoreNew": "Zvibodzwa zveUtano · Zvitsva",
    "letsBuildScore": "Ngativakei zvibodzwa zveutano hwako tese",
    "oneHealthyHabitAtATime": "Tsika imwe neimwe ine utano panguva imwe.",
    "nextCheck": "Kuzvitarisa kunotevera:",
    "todayAt8pm": "nhasi na 8:00 PM",
    "wellnessTipForYou": "Zano reUtano ranhasi · Rako",
    "wellnessTipForFactor": "Zano reUtano ranhasi · Re{{factor}} yako",
    "logged": "Zvanyorwa",
    "gotIt": "Ndazvinzwisisa 👍",
    "gladToSeeYou": "Tafara kukuonai nhasi 💚",
    "takesLessThan60Sec": "Zvinotora nguva iri pasi pemasekonzi 60",
    "scoreReadyWhenYou": "Zvakagadzirira kana wagadzirira",
    "scoreCompleteFirstCheck": "Pedzisa kuzvitarisa utano kwako kwekutanga kuti uwane mazano akakufanira.",
    "scoreExcellent": "Zvakanaka Kwazvo",
    "scoreSupportExcellent": "Utano hwako huri pamusoro nhasi. Rambira ipapo.",
    "scoreGood": "Zvakanaka",
    "scoreSupportGood": "Uri kuita zvakanaka. Ramba uchiita tsika dzako dzakanaka.",
    "scoreModerate": "Zviri Pakati Nepakati",
    "scoreSupportModerate": "Uri kuita zvakanaka, asi pane nzvimbo shoma dzinoda kutariswa.",
    "scoreNeedsAttention": "Zvinoda Kutariswa",
    "scoreSupportNeedsAttention": "Utano hwako hunoda kutariswa nhasi. Shanduko diki dzinogona kubatsira kuhuvandudza."
  },
  "emailVerify": {
    "bannerWithEmail": "Tapota simbisa imeyiri yako ({{email}}) kuti tichengetedze akaundi yako uye kukurumidza kukupa zviyeuchidzo zvezuva nezuva.",
    "bannerNoEmail": "Tapota simbisa imeyiri yako kuti tichengetedze akaundi yako uye kukurumidza kukupa zviyeuchidzo zvezuva nezuva.",
    "sending": "Zviri kutumirwa...",
    "resend": "Tumirazve imeyiri",
    "sentToast": "Imeyiri yekusimbisa yatumirwa. Tapota tarisa mubhokisi rako retsamba.",
    "sendFailToast": "Tatsatadza kutumira imeyiri yekusimbisa. Edza zvakare gare gare."
  },
  "forgotPassword": {
    "title": "Wakanganwa Password?",
    "subtitle": "Usazvidya moyo! Nyora imeyiri yako tigokutumira mirairo yekugadzirisa imwe.",
    "emailLabel": "Imeyiri",
    "emailPlaceholder": "zita@example.com",
    "sendResetLink": "Tumira Link yekugadzirisa",
    "sending": "Zviri kutumirwa...",
    "backToLogin": "Dzokera pakupinda (Login)",
    "resendLink": "Tumirazve imeyiri",
    "successTitle": "Tarisa Imeyiri Yako",
    "successBody": "Kana pane akaundi ine imeyiri iyi {{email}}, tatumira link yekugadzirisa password.",
    "linkExpires": "Link iyi inopera mushure memamineti 30.",
    "successToast": "Tarisa imeyiri yako kuti uwane mirairo",
    "errEmptyEmail": "Tapota nyora imeyiri yako",
    "errInvalidEmail": "Tapota nyora imeyiri yechokwadi",
    "errNetwork": "Tatsatadza kubata sevha. Tarisa internet yako uedze zvakare.",
    "errGeneric": "Tatsatadza kutumira imeyiri yekugadzirisa. Tapota edza zvakare kana kubata rubatsiro."
  },
  "resetPassword": {
    "title": "Gadzira Password Itsva",
    "subtitle": "Gadzira password yakasimba yeakaundi yako",
    "newPasswordLabel": "Password Itsva",
    "newPasswordPlaceholder": "Nyora password itsva",
    "confirmPasswordLabel": "Simbisa Password",
    "confirmPasswordPlaceholder": "Dzokorora kunyora password itsva",
    "requirementsHint": "Inofanira kuva nemavara (characters) asiri pasi pe 8, iine vara guru, diki, nenhamba",
    "resetPassword": "Chinja Password",
    "resetting": "Zviri kuchinjwa...",
    "successTitle": "Password yachinjwa zvinobudirira!",
    "successBody": "Iye zvino unogona kupinda nepassword yako itsva.",
    "successToast": "Password yachinjwa zvinobudirira!",
    "goToLogin": "Enda pakupinda (Login)",
    "invalidLinkTitle": "Link iyi haishande",
    "invalidLinkBody": "Link iyi yekuchinja password haishande kana kuti yakapera nguva.",
    "requestNewLink": "Kumbira imwe Link",
    "showPassword": "Ratidza password",
    "hidePassword": "Vanza password",
    "errInvalidLink": "Link haishande",
    "errMismatch": "Mapassword haana kufanana",
    "errTooShort": "Password inofanira kuva nemavara 8 kana kudarika",
    "errExpiredToken": "Link iyi yapera nguva kana kuti haishande. Tapota kumbira imwe.",
    "errNetwork": "Tatsatadza kubata sevha. Tarisa internet yako uedze zvakare.",
    "errGeneric": "Tatsatadza kuchinja password. Tapota edza zvakare."
  },
  "tips": {
    "water1": "Kunwa mvura mukati memamineti 30 wamuka kunogona kubatsira kupa muviri mvura nesimba.",
    "water2": "Girazi remvura usati wadya zvidyo zvako inzira nyoro yekugara uine mvura yakakwana.",
    "water3": "Kuisa chimedu cheremoni kana mashizha eminti mumvura kunoita kuti kunwa mvura kunakidze.",
    "meals1": "Kuwedzera muriwo mumwe chete pazuva kunobatsira ura nehana.",
    "meals2": "Tsumbu remandere kana mhodzi panguva yemangwanani rinokupa simba zuva rese.",
    "meals3": "Muchero unodyiwa wose uri nani pane muto wawo (juice) — faibha inobatsira kuchengetedza shuga mumuviri zvakanaka.",
    "steps1": "Kufambafamba kwemamineti gumi mushure mekudya kunobatsira muviri wako kugadzira shuga zvakanaka.",
    "steps2": "Kutatamura muviri kwemamineti mashanu mangwanani kunobvisa kusimira kwemuviri nekukupa rugare zuva rose.",
    "steps3": "Kukwira masitepisi kunyangwe kamwe chete pazuva kunosimbisa mwoyo zvishoma nezvishoma vhiki dzichipfuura.",
    "sleep1": "Kudzima mwenje awa imwe usati waenda kunorara kunobatsira muviri wako kuzorora kuitira kurara kwakadzama.",
    "sleep2": "Kumuka nenguva imwe chete mazuva ose — kunyangwe nekupera kwevhiki — kunoita kuti uvate zvakanaka.",
    "sleep3": "Kuwana chiedza chezuva chemangwanati kwemamineti gumi kunobatsira kugadzirisa nguva yako yekurara zvakasikwa.",
    "general1": "Mamineti maviri ekufema zvishoma nezvishoma anogona kuderedza kushushikana nekuita kuti ufungisise zvakanaka.",
    "general2": "Cherechedza chinhu chimwe chete chaunotenda nhasi — kufunga zvakanaka kunovaka utano hwenjere.",
    "general3": "Wazviita nhasi. Ndiyo tsika inoita kuti dzimwe tsika dzose dzive nyore kutevera."
  },
  "factors": {
    "hydration": "kunwa mvura",
    "nutrition": "kudya kunovaka muviri",
    "movement": "kurovedza muviri",
    "sleep": "kurara"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "Zvakundikana kuwanikwa kwekudya",
    "prefsSaved": "Zvamunofarira pakudya zvashandurwa! Kuri kuvandudzwa...",
    "prefsSaveFail": "Zvakundikana kuchengetedza zvamunofarira",
    "newOptionsFail": "Zvakundikana kuwana zvimwe zvekudya",
    "invalidZip": "Ndapota pinda zip kodhi ine nhamba shanu",
    "noVendorsArea": "Hapasati pava nevanotengesa munzvimbo ino. Tiri kuramba tichiwedzera!",
    "vendorsFetchFail": "Zvakundikana kuwana vanotengesa",
    "selectVendorFirst": "Ndapota tangai masarudza nzvimbo inotengesa",
    "removedFromCart": "Zvabviswa mungoro",
    "orderPlaced": "Zvatengwa zvabudirira! 🎉",
    "enterZipFirst": "Ndapota tangai mapinda zip kodhi yenyu muchikamu chekutumirwa",
    "mealNotAvailable": "Kudya uku hakuwanikwi munzvimbo yenyu parizvino",
    "mealUnavailable": "Kudya uku hakuwanikwi nevanotengesa vari pedyo",
    "vendorOptionsFail": "Zvakundikana kuwana vanotengesa",
    "favoriteSaveFail": "Zvakundikana kuchengetedza zvamunofarira",
    "removedFromFavorites": "Zvabviswa pazvinhu zvamunofarira",
    "favoriteRemoveFail": "Zvakundikana kubvisa pazvamunofarira",
    "cartEmpty": "Ngoro yenyu haina chinhu",
    "noMealOptions": "Hapana kwekudya kuripo",
    "loadingOptions": "Kudya kuri kutsvagwa...",
    "selectPreferences": "Sarudzai Zvamunofarira Pakudya",
    "mealBuilder": "Kuronga Kudya",
    "myFavorites": "Zvamunofarira",
    "myFavoriteMeals": "Zvekudya Zvamunofarira",
    "noFavoritesYet": "Hapasati pava nezvekudya zvamunofarira!",
    "price": "Mutengo",
    "delivery": "Kutumirwa",
    "deliveryFee": "Mari yekutumira",
    "distance": "Urefu hwerwendo",
    "subtotal": "Mari isati yabviswa mitero",
    "total": "Mari yose",
    "orderNumber": "Nhamba yeOda",
    "vendor": "Mutengesi",
    "totalAmount": "Mari Yose",
    "estimatedDelivery": "Nguva inofungidzirwa kusvika",
    "whyThisMeal": "Sei kudya uku kwakakufanira",
    "selectThisMeal": "Sarudzai Kudya Uku",
    "swapMeal": "Chinja Kudya",
    "orderThisMeal": "Odhai Kudya Uku",
    "notAvailableNearYou": "Hakuwanikwi pedyo nemi",
    "tryAdjustingPrefs": "Edzai kuchinja zvamunofarira kuti muone mamwe mazano ekudya",
    "myMealPlanSummary": "Pfupiso yeChirongwa Changu Chekudya",
    "saveCompletePlan": "Chengetedza Chirongwa Chose",
    "yourFoodPreferences": "Zvamunofarira Pakudya",
    "editPreferences": "Gadzirisai Zvamunofarira",
    "healthyMealDelivery": "Kutumirwa Kwekudya Kunovaka Muviri",
    "enableDelivery": "Batidza dzekutumirwa",
    "enterZipCode": "Pinda Postcode / ZIP Kuti Uone Kudya Kuripo",
    "enterPostcode": "Pinda Postcode / ZIP Kodhi",
    "postcodePlaceholder": "semuenzaniso, 10001",
    "postcodePartialHint": "Ndapota pinda postcode yose kuti uwane mhinduro dzenzvimbo yako.",
    "noLocalPartnersFallback": "Hapasati pawanikwa vanotishandira pedyo. Tiri kukurumbidzirai zvinoshandiswa pakubika zvinowanikwa munharaunda.",
    "noLivePartnersFallback": "Hapana vashandiri ve HealthLoop vanotengesa kudya munzvimbo yenyu parizvino.",
    "culturalNutritionTitle": "Zvekudya Zvakanaka Munharaunda",
    "culturalNutritionSubtitle": "Gwara reupenyu hune hutano — zvinoenderana netsika dzenyu, ruzivo rwehutano, uye nzvimbo yenyu.",
    "viewIngredientGuidance": "Ona Gwara",
    "popularWellnessTitle": "Zvekudya Zvinovaka Muviri Pedyo Nemi",
    "popularWellnessIntro": "Zvinoshandiswa pakubika zvinodiwa nevanhu munzvimbo yenyu zvinovaka muviri.",
    "subsectionPopularFoodsTitle": "Zvekudya Zvamazuva Ose",
    "subsectionCulturalIngredientsTitle": "Mazano eZvinobikwa Zvemuno",
    "subsectionHealthySwapsTitle": "Mazano ekuchinja Zvekudya",
    "subsectionLocalEnvironmentTitle": "Zveutano Munharaunda",
    "subsectionLocalEnvironmentIntro": "Nzvimbo dzinowanzoonekwa vanhu munharaunda yenyu vachiwana zvekudya zvine hutano.",
    "findLocalTitle": "Zvekudya Zveutano Pedyo Nemi",
    "findLocalSubtitle": "Tsvagai vanotengesa zvekudya, zvitoro, uye zvinobikwa zvemuno munzvimbo yenyu.",
    "findOptions": "Tsvaga",
    "searching": "Kuri kutsvagwa...",
    "nearbyVendorsFound": "Pawanikwa nzvimbo {{count}} dzeutano pedyo",
    "orderHintEnabled": "Dzvanya \"Odhai Kudya Uku\" kuitira kuona mitengo yevatengesi.",
    "orderHintDisabled": "Batidza kwekutumirwa pamusoro kuti ugone kuoda zvekudya izvi.",
    "localIngredientTitle": "Kuwanikwa kweZvinobikwa Munharaunda",
    "localIngredientIntro": "Zvekudya zvemuno uye kwaningawanikwa munharaunda.",
    "lookFor": "Tsvagai",
    "noVendorsFallback": "Hapasati pava nevanotengesa kudya munharaunda ino — asi mazano ezvinobikwa ari pamusoro anoshanda muzvitoro nemumisika yemuenzvimbo yenyu.",
    "showingMealsFrom": "Kuratidza kudya kubva ku",
    "sectionSnapshot": "Muchidimbu nezveKudya Kanhasi",
    "sectionSnapshotSubtitle": "Kutarisa kunwa mvura, simba riri muchikafu (calories), uye kuenzanisa kudya kwanhasi.",
    "snapshotHydration": "Mvura",
    "snapshotHydrationHint": "Simbirirai kunwa magirazi matanhatu kusvika kumasere nhasi.",
    "snapshotCalories": "Simba (Calories)",
    "snapshotCaloriesHint": "Zvekutarisa izvi zviri kuuya munguva pfupi.",
    "snapshotBalance": "Kuenzanisa Kudya",
    "mealsLogged": "kudya kwakasarudzwa",
    "snapshotTip": "Zano reUtano",
    "snapshotTipHint": "Wedzera muriwo mune zvamuri kudya zvinotevera.",
    "sectionRecommendations": "Mazano Akachenjera",
    "sectionRecommendationsSubtitle": "Gwara rezvekubikisa zvemunharaunda nemazano ekuchinja kudya.",
    "sectionGoals": "Zvinangwa zveKudya",
    "sectionGoalsSubtitle": "Tarisa zvinangwa zvine basa kwauri.",
    "goalWeight": "Kurerutsa Muviri",
    "goalWeightDesc": "Kudya kwakarongwa kuitira kurema kwemuviri kwakakodzera.",
    "goalEnergy": "Simba reMuviri",
    "goalEnergyDesc": "Simba rakaringana rekushanda zuva rose.",
    "goalImmunity": "Kudzivirira Zvirwere",
    "goalImmunityDesc": "Zvekudya zvine mavitamini anobatsira kudzivirira muviri.",
    "goalFamily": "Utano hweMhuri",
    "goalFamilyDesc": "Zvekudya zvevana namadzimai akazvitakura zvirimo.",
    "sectionGuidance": "Gwara reKudya",
    "sectionGuidanceSubtitle": "Mazano ekudya kwemangwanani, kwemasikati, kwemanheru, neezvokunanzva.",
    "futureNutritionTitle": "Zvekudya Zvamangwana",
    "futureNutritionBody": "Mazano ezvekudya, kubatana nevanotengesa, uye utano hwemhuri zvichawedzerwa mu HealthLoop munguva inotevera.",
    "comingSoon": "Zvinouya Munguva Pfupi",
    "coverageLocalStores": "Zvitoro zveutano zvemuno",
    "coverageLocalFarms": "Mapurazi emuno",
    "coverageCertifiedVendors": "Vatengesi vanozivikanwa",
    "coverageFreshProduce": "Zvekudya zvinyoro",
    "medWellnessFutureTitle": "Utano neMishonga",
    "medWellnessFutureDesc": "Inobatanidza kudya kwako nezano rezveutano rakakodzera. Izvi zvichawanikwa pa Support & Help.",
    "pharmacyAssistFutureTitle": "Rubatsiro rwePharmacy",
    "pharmacyAssistFutureDesc": "Tsvaga mafamasii ari pedyo nechiyeuchidzo chemishonga pamwe chete nekudya kwako. Izvi zvichawanikwa pa Support & Help.",
    "savePreferences": "Chengetedza Zvamunofarira",
    "quickAccessSavedMeals": "Kuona kudya kwawakachengetedza nekukasira",
    "saveMealsFromBuilder": "Chengetedza kudya kubva pachikamu che Kuronga Kudya",
    "chooseVendor": "Sarudza mutengesi kuitira kuoda kudya uku",
    "yourCart": "Ngoro Yenyu",
    "addMealsToStart": "Wedzera kudya kubva pazviripo kuti utange",
    "orderPlacedDesc": "Oda yako yekudya kune utano yabudirira",
    "continueShopping": "Ramba uchitsvaga",
    "trackOrder": "Tevedza Oda",
    "healthyStoresTitle": "Zvitoro neMisika yeZvekudya Zvinovaka Muviri Pedyo Newe",
    "healthyStoresIntro": "Mhando dzezvitoro zvinoenderana netsika dzekutsvaga munharaunda yako — ndezvekukupa mazano, kwete zvekutumira.",
    "healthyStoresGuidanceTitle": "Mazano ekutenga zvekudya zvine utano",
    "healthyStoresDisclaimer": "HealthLoop inopa mazano ezvekugara zvakanaka nekurudziro yekutenga zvine utano chete — kwete mazano ezvekurapa kana kudya kwechirwere.",
    "healthyStores": {
      "organic": {
        "type": "Zvitoro zvezvinhu zvisina mishonga (Organic)",
        "description": "Zvirimwa zvitsva zvisina mishonga inouraya tupukanana neizvo zvisina kunyanya kugadzirwa nemichina.",
        "tags": [
          "Zvekudya zvizere",
          "Zvirimwa zvitsva"
        ]
      },
      "farmers": {
        "type": "Misika yevarimi",
        "description": "Michero nemiriwo yenguva iyoyo, nezvimwe zvirimwa zvechivanhu zvinobva kuvarimi chaivo.",
        "tags": [
          "Zvemunharaunda",
          "Zvemushoko"
        ]
      },
      "african": {
        "type": "Zvitoro zvezvirimwa zvemuAfrica",
        "description": "Madhumbe, mabanana makuru (plantains), muriwo wemashizha, nezvimwe zvekudya zvekuWest / East Africa.",
        "tags": [
          "Zvechivanhu",
          "Zvirimwa zvitsva"
        ]
      },
      "caribbean": {
        "type": "Misika yezvekudya zvekuCaribbean",
        "description": "Mufushwa, mufarinya, mhiripiri, ackee, breadfruit nezvimwe zvekudya zvemuzvitsuwa.",
        "tags": [
          "Zvechivanhu",
          "Zvekudya zvizere"
        ]
      },
      "asian": {
        "type": "Zvitoro zvemuriwo wekuAsia",
        "description": "Bok choy, daikon, midzi yelotus, tofu, nezvirimwa zvinonhuwirira zvekuAsia.",
        "tags": [
          "Zvechivanhu",
          "Zvirimwa zvitsva"
        ]
      },
      "halal": {
        "type": "Misika yezvekudya zveHalal",
        "description": "Nyama dzine mafuta mashoma dzakabvumidzwa neHalal, zvirimwa zvitsva nezvinonhuwirira zvechivanhu.",
        "tags": [
          "Halal",
          "Zvechivanhu"
        ]
      },
      "mediterranean": {
        "type": "Misika yezvekudya zvekuMediterranean",
        "description": "Mafuta emuorivhi, nyemba, zvinonhuwirira zvitsva, nembeu dzizere (whole grains).",
        "tags": [
          "Zvechivanhu",
          "Zvekudya zvizere"
        ]
      },
      "wellness": {
        "type": "Zvitoro zvakanangana nekugara zvakanaka",
        "description": "Zvekudya zvakasarudzwa zvine utano, zvinobva kuzvirimwa (plant-based) nezvimwe zvakachena.",
        "tags": [
          "Zvekudya zvizere",
          "Zvinobva kuzvirimwa"
        ]
      }
    },
    "healthyShoppingTips": [
      "Tanga kutsvaga kumativi echitoro — zvirimwa zvitsva, nyama dzisina mafuta nezvimwe zvinotsiva mukaka zvinowanzoiswa kumicheto.",
      "Sarudza zvekudya zvizere zvine chinhu chimwe chete panzvimbo peizvo zvakagadzirwa zvakanyanya nemichina.",
      "Sarudza zvirimwa zvemunharaunda zvemushoko iroro — zvinowanzova zvitsva, zvakachipa uye zvine simba mumuviri.",
      "BVunza vatengesi nezvekwakabva zvekudya nemasikirwo azvo — vazhinji vanofara kukuudza."
    ]
  },
  "messages": {
    "success": "Zveitika!",
    "error": "Pane chakanganisika",
    "saved": "Zvachengetedzwa",
    "updated": "Zvagadziriswa",
    "deleted": "Zvadzimwa",
    "confirmDelete": "Mune chokwadi chekuti munoda kudzima izvi?",
    "networkError": "Dambudziko reindaneti. Ndapota edzai zvakare.",
    "somethingWrong": "Pane chakanganisika",
    "failedToLoad": "Zvakundikana kuvhura peji",
    "offlineMode": "Huna indaneti - kuratidza zvinhu zvishoma",
    "locationDenied": "Mvumo yenzvimbo yarambwa. Tarisai zvigadziriso zvebhurauza yenyu.",
    "locationUnavailable": "Ruzivo rwenzvimbo haruwanikwi",
    "locationTimeout": "Kutsvaga nzvimbo kwanonoka. Ndapota edzai zvakare.",
    "locationError": "Zvakundikana kuwana nzvimbo yenyu",
    "locationGranted": "Mvumo yenzvimbo yapihwa! Kuratidza zviri pedyo",
    "locationNotSupported": "Indaneti yenyu haikwanisi kutsvaga nzvimbo",
    "requestingLocation": "Kukumbira mvumo yenzvimbo..."
  },
  "trust": {
    "medicalDisclaimer": "Yambiro yeUtano",
    "privacySecure": "Ruzivo rwenyu rwakachengetedzka",
    "dataEncrypted": "Ruzivo rwenyu rwakavharwa uye ndechakavanzika",
    "notMedicalAdvice": "Harisi zano rechiremba",
    "consultProvider": "Nguva dzose bvunzai vanamukoti kana vanachiremba venyu",
    "evidenceBased": "Gwara rinoenderana netsvakurudzo",
    "generalEducation": "Dzidzo yeutano ruzhinji",
    "preventiveGuidance": "Gwara rekudzivirira zvirwere",
    "lifestyleSupport": "Ruzivo rwekugadzirisa mararamiro",
    "lastUpdated": "Rakapedzisira kuvandudzwa",
    "expertReviewed": "Rakaongororwa nenyanzvi",
    "aiGenerated": "Ruzivo rwakagadzirwa neungwaru hwemuchina (AI)",
    "disclaimerShort": "HealthLoop inopa dzidzo yeutano uye haisi nzvimbo inotsiva vanachiremba.",
    "disclaimerFull": "HealthLoop inotsigira kudzivirira zvirwere uye kuziva utano hwako mapfuvira. Tinopa dzidzo yeutano, kutevedza tsika dzeutano, uye ruzivo rweutano. Izvi hazvisirizvo zvinotsiva rubatsiro rwekurapwa. Nguva dzose bvunzai vanachiremba nezvekurapwa kana kuongororwa kwezvirwere.",
    "trustBanner": {
      "title": "HealthLoop iri pano kutsigira rwendo rwenyu rweutano",
      "description": "Tinopa dzidzo yeutano ruzhinji negwara rekudzivirira zvirwere zvichibva kunzvimbo dzinovimbika. Izvi hazvitsive mazano evanamukoti nevanachiremba. Nguva dzose taurai nevanachiremba pamusoro pezveutano hwenyu."
    }
  },
  "health": {
    "preventiveHealth": "Kutarisa Kudzivirira Zvirwere",
    "educationHub": "Nzvimbo yeDzidzo",
    "engagementWidget": "Zvekuita",
    "wellnessCheckIn": "Kuzviongorora Utano",
    "todaysMetrics": "Zviyero zveNhasi",
    "bloodPressure": "BP (Blood Pressure)",
    "heartRate": "Kurova kweMoyo",
    "weight": "Kurema",
    "sleep": "Kurara",
    "waterIntake": "Mvura Yanwiwa",
    "exercise": "Kurovedza muviri",
    "logMetric": "Nyora Chiyero",
    "viewHistory": "Ona Zvakamboitwa"
  },
  "aiInsights": {
    "title": "Ruzivo rweUtano rweAI",
    "comingSoon": "Ruzivo rwenyu ruri kuunganidzwa",
    "comingSoonDesc": "Pedzai kuzviongorora kwemazuva mashoma kuti tikupei mazano anokubatsirai.",
    "learnMore": "Dzidza zvimwe",
    "evidenceSources": {
      "WHO": "Kubva pagwara reWHO",
      "NHS": "Zvichienderana nemazano eNHS",
      "CDC": "Zvinotsigirwa negwara reCDC",
      "RESEARCH": "Kubva patsvakurudzo dzenyanzvi",
      "CLINICAL": "Zvinotsigirwa nekuongorora kwekurapa"
    }
  },
  "dailyInsight": {
    "title": "Zano reUtano reZuva neZuva",
    "gettingStarted": "Kutanga",
    "focus": "Tarisa Pano",
    "quickInsight": "Zano Rekukasira",
    "simpleExplanation": "Tsananguro Iri Nyore",
    "realLifeImpact": "Zvazvinoreva muUpenyu",
    "yourActionStep": "Zvamunogona Kuita",
    "basedOnYour": "Zvichienderana ne",
    "personalizedFor": "Zvakagadzirirwa imi zvichienderana neuzivo hwenyu hweutano",
    "getNewInsight": "Wana rimwe zano",
    "newInsightLoaded": "Zano idzva rawanikwa! 💡",
    "failedToRefresh": "Zvakundikana kuvandudza zano",
    "priority": {
      "high": "Ngatitarisei Pano",
      "medium": "Zvinokosha Kuziva"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "Hapana yambiro yeutano parizvino",
    "noAlertsDesc": "Uri kuchengetedza tsika dzeutano. Ramba wakadaro!",
    "whatYouCanDo": "Zvamunogona kuita:",
    "viewMealSuggestions": "Ona Mazano Ekudya Ako"
  },
  "engagement": {
    "currentStreak": "Mazuva Akarongwa",
    "bestStreak": "Mazuva Akanyanya",
    "thisWeek": "Vhiki Rino",
    "exerciseDays": "Mazuva eKurovedza",
    "hydrationDays": "Mazuva eKunwa Mvura",
    "healthMetricsLogged": "Zviyero Zvakanyorwa",
    "weeklyGoalsProgress": "Kufambira mberi kweVhiki",
    "completed": "zvapedzwa",
    "days": "mazuva",
    "keepGoing": "Ramba uchienderera mberi!",
    "personalRecord": "Nhoroondo itsva!",
    "goalMet": "Chinangwa chazadziswa!"
  },
  "reminders": {
    "title": "Zviyeuchidzo zveUtano",
    "subtitle": "Ramba uri mugwara nezviziviso zveutano",
    "breakfast": "Chiyeuchidzo cheKudya kweMangwanani",
    "lunch": "Chiyeuchidzo cheKudya kwemasikati",
    "dinner": "Chiyeuchidzo cheKudya kwemanheru",
    "water": "Kunwa Mvura",
    "movement": "Kumbozorora Nekufamba",
    "sleep": "Chiyeuchidzo cheKurara",
    "wellness": "Kuzviongorora Utano",
    "healthLogging": "Kunyora Zviyero zveUtano",
    "annualCheckup": "Kuongororwa Kwemugore",
    "enable": "Batidza",
    "disable": "Dzima",
    "customize": "Gadzirisa Nguva",
    "stayConsistent": "Ramba Wakasimba neZviyeuchidzo",
    "setupFriendly": "Gadzira zviyeuchidzo zvinyoro kuti uvake tsika dzeutano.",
    "customizeWhen": "Unogona kugadzirisa nguva yaunoda kuziviswa.",
    "supportive": "Usazvidya moyo - zviyeuchidzo zvedu ndezvekurumbidza chete! 💚",
    "noPreferences": "Hapasati pava nezviyeuchidzo",
    "noPreferencesDesc": "Tashaya zvigadziriso zvako. Zvichida unogona kunge uri mutsva pano.",
    "retryLoading": "Edza Zvakare",
    "saveSettings": "Chengetedza Zvigadziriso",
    "saving": "Kuri kuchengetedzwa..."
  },
  "empty": {
    "startJourney": "Tanga Rwendo rweUtano",
    "startJourneyDesc": "Tanga rwendo rwako nhasi! Tiudze kuti uri kunzwa sei kuti uwane mazano akakunakira.",
    "completeFirstCheckIn": "Tanga Kuzviongorora",
    "stayOnTrack": "Ramba uri muGwara",
    "stayOnTrackDesc": "Ramba uchiita zvawakaronga 💊 Wedzera mishonga yako kuti uwane zviyeuchidzo zvinyoro.",
    "addFirstMedication": "Wedzera Mushonga",
    "learnMedicationSafety": "Dzidza kuchengetedzeka kwemishonga",
    "buildMealLibrary": "Vaka Mazano Ako eKudya",
    "buildMealLibraryDesc": "Hapasati pava nezvekudya zvawakachengetedza.",
    "exploreMealOptions": "Tsvaga Zvekudya",
    "insightsAwait": "Mazano Akamirira",
    "insightsAwaitDesc": "Pedza kuzviongorora zuva nezuva kuti uwane mazano eutano.",
    "startDailyCheckIn": "Tanga Kuzviongorora Kwezuva",
    "learnAboutInsights": "Dzidza nezvemazano",
    "buildingStory": "Kuvaka Nhoroondo Yako",
    "buildingStoryDesc": "Hapasati pava neruzivo rwakanyorwa. Mafambiro eutano hwako achaonekwa pano.",
    "completeCheckIn": "Pedza Kuzviongorora",
    "tipComplete7Days": "Zano: Pedza mazuva manomwe uchiita izvi kuti uone mafambiro eutano hwako.",
    "startTrackingHabits": "Tanga Kutarisa Tsika Dzeutano",
    "startTrackingHabitsDesc": "Hapasati pava netsika dzanyorwa. Zviito zvidiki zvezuva nezuva ndizvo zvinovaka utano.",
    "trackFirstHabit": "Tanga Kunyora Tsika",
    "getMoving": "Fambisa Muviri",
    "getMovingDesc": "Hapasati pava nekurovedza muviri kwanyorwa. Kunyange maminitsi gumi anobatsira.",
    "logActivity": "Nyora Zvawaita",
    "allCaughtUp": "Zvese Zvakarungwa!",
    "allCaughtUpDesc": "Huna zviziviso zvitsva parizvino.",
    "noResultsFound": "Hapana Chawanikwa",
    "noResultsFoundDesc": "Hatina kuwana mhinduro dze \"{query}\". Edza kutsvaga neimwe nzira."
  },
  "footer": {
    "tagline": "Shamwari yako inoshandisa AI pakuchengetedza hutano",
    "builtWith": "Rudo rwakaiswa parwendo rwako rwehutano",
    "allRightsReserved": "Kodzero dzose dzakachengetedzwa.",
    "about": "Nezvedu",
    "privacy": "Zvakavandika",
    "terms": "Mitemo",
    "contact": "Taura nesu",
    "helpCenter": "Rubatsiro"
  },
  "modals": {
    "feedback": {
      "title": "Tiudzei maonero enyu",
      "subtitle": "Tibatsirei kuvandudza HealthLoop",
      "whatWorking": "Chii chiri kufamba zvakanaka?",
      "whatImprove": "Chii chatinofanira kugadzirisa?",
      "placeholder": "Nyora maonero enyu pano...",
      "thankYou": "Maita basa nemaonero enyu!",
      "submitted": "Maonero enyu anotibatsira kuti HealthLoop ive nani."
    },
    "reportProblem": {
      "title": "Taura dambudziko rawasangana naro",
      "subtitle": "Tibatsirei kugadzirisa dambudziko riri muapp",
      "describe": "Tsanangura dambudziko racho",
      "placeholder": "Chii chaitika? Tapota tsanangura zvakadzama...",
      "optional": "Zvimwe: Matanho awatora kuti dambudziko ribude",
      "stepsPlaceholder": "1. Ndadzvanya pa...\n2. Zvazoita...",
      "thankYou": "Maita basa nekutizivisa!",
      "submitted": "Ticharitarisa izvozvi."
    },
    "mealPreferences": {
      "title": "Gadzirisa zvekudya zvako",
      "subtitle": "Tiudzei rudzi rwekudya rwamunofarira",
      "cuisines": "Zvekudya zvamunoda",
      "selectCuisines": "Sarudzai zvose zvamunofarira",
      "dietary": "Zvamunodya nezvamusingadyi",
      "selectDietary": "Sarudzai magadzirirwo ekudya kwenyu",
      "allergies": "Zvinhu zvamusingadi kana zvinokurwarisai",
      "allergiesPlaceholder": "senge: nzungu, hove dzemugungwa, gluten",
      "save": "Chengetedza",
      "saving": "Kuchengetedza..."
    },
    "upgrade": {
      "title": "Wana zvese zvePremium",
      "subtitle": "Vhura zvose zviri muapp",
      "features": "Zvinowanikwa muPremium",
      "getStarted": "Tanga izvozvi",
      "learnMore": "Dzidza zvimwe"
    }
  },
  "login": {
    "title": "Nzvimbo yako yekuchengetedza hutano",
    "subtitle": "Tevedzera, dzidza, uye tora matanho matambudziko asatiakura. Yakagadzirirwa kudzivirira, kudzidzisa, uye hutano hwakanaka.",
    "email": "Email",
    "password": "Password",
    "signIn": "Pinda",
    "signingIn": "Kupinda...",
    "forgotPassword": "Wakanganwa Password?",
    "noAccount": "Hauna account?",
    "createAccount": "Gadzira imwe",
    "biometricLogin": "Pinda uchishandisa Biometrics",
    "biometricHelper": "Shandisa chigunwe, Face ID, kana Windows Hello",
    "authenticating": "Kuzvitsauranisa...",
    "vendorPartner": "Muri vatinoshanda navo here (vendor)?",
    "vendorLogin": "Login yevendor",
    "emailRequired": "Tapota pinza email yako kutanga",
    "biometricSuccess": "Wapinda zvakanaka uchishandisa biometrics! 🎉",
    "noPasskeys": "Hauna kugadzira biometric login. Tapota pinda nepassword pakutanga.",
    "biometricCancelled": "Biometric login yakanzurwa",
    "biometricFailed": "Biometric login yaramba. Tapota pinda nepassword."
  },
  "register": {
    "title": "Batana ne HealthLoop",
    "subtitle": "Tanga rwendo rwako rwekuchengetedza hutano nhasi",
    "fullName": "Zita rakazara",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Dzokorora Password",
    "createAccount": "Gadzira Account",
    "haveAccount": "Watova neaccount kare?",
    "signIn": "Pinda",
    "creating": "Kugadzira account...",
    "passwordTooShort": "Password inofanira kuva nemavara anodarika matsere",
    "setupBiometric": "Gadzira Biometric Login",
    "setupBiometricDesc": "Shandisa chigunwe, Face ID, kana Windows Hello kuti upinde nekukurumidza uye zvakachengeteka",
    "setupNow": "Gadzira Biometric Login",
    "skipForNow": "Rega kudaro parizvino",
    "settingUp": "Kugadzira...",
    "benefit1": "Hauchafaniri kuyeuka mapassword",
    "benefit2": "Zvakachengeteka zvikuru ne biometrics",
    "benefit3": "Pinda nekungodzinya kana kutarisa chete",
    "biometricPrivacy": "Zvebiometrics zvako hazvibvi parunhare rwako",
    "biometricSuccess": "Biometric login yagadzirwa zvakanaka! 🎉",
    "biometricFailed": "Kugadzira biometric login kwaramba. Unogona kuzogadzira mu settings.",
    "biometricSetupLater": "Unogona kuzogadzira biometric login mu profile settings yako"
  },
  "womensHealthPage": {
    "title": "Hutano hweMadzimai",
    "subtitle": "Tevedzera mazuva ako, zvauri kunzwa, uye hutano hwako",
    "cycleOverview": "Zvemazuva ako",
    "currentPhase": "Paugaro hwauri",
    "nextPeriod": "Mazuva anotevera anotarisirwa",
    "logPeriod": "Nyora mazuva",
    "logSymptoms": "Nyora zvauri kunzwa",
    "insights": "Zvinobuda pamazuva ako",
    "tips": "Mazano anoenderana nemazuva ako",
    "history": "Zvakamboitika kumashure",
    "noData": "Hapana ruzivo rwamazuva rwakanyorwa",
    "noDataDesc": "Tanga kunyora mazuva ako kuti ugone kuwana mazano anotevera kuitira hutano hwako.",
    "startTracking": "Tanga kutevedzera"
  },
  "notifications": {
    "title": "Zviziviso",
    "markAllRead": "Zvitarise sezvakaverengwa zvose",
    "noNotifications": "Hapana zviziviso zvitsva",
    "viewAll": "Ona zvose"
  },
  "familyHealth": {
    "title": "Hutano hwemhuri neVana",
    "subtitle": "Rubatsiro rwekuchengetedza hutano hwemhuri yako yose",
    "tabImmunizations": "Nhomba",
    "tabEducation": "Dzidzo",
    "tabReminders": "Zviyeuchidzo",
    "tabPlanner": "Zvekuronga zvemhuri",
    "immunizations": {
      "title": "Ruzivo rweNhomba",
      "subtitle": "Gara uchiziva nezvenhomba dzinokurudzirwa",
      "recommendedSchedule": "Mazuva anokurudzirwa",
      "byAge": "Nezera rezera",
      "infants": "Vacheche (0-12 mwedzi)",
      "toddlers": "Vana vadiki (1-3 makore)",
      "preschool": "Vana vechikoro (4-6 makore)",
      "schoolAge": "Vana vechikoro (7-12 makore)",
      "teens": "Vechidiki (13-18 makore)",
      "adults": "Vakuru",
      "learnMore": "Dzidza zvimwe",
      "consultDoctor": "Gara uchitaura nanamukoti kana vanachiremba kuti uwane mazano akakodzera panyaya dzenhomba",
      "upcomingReminders": "Zviyeuchidzo zvenhomba dzinouya",
      "noReminders": "Hapana zviyeuchidzo zvenhomba",
      "addReminder": "Wedzera chiyeuchidzo chenhomba",
      "reminderFor": "Chiyeuchidzo cha",
      "dueDate": "Zuva racho",
      "notes": "Mamwe mashoko",
      "markComplete": "Cherechedza sekunge zvaitwa"
    },
    "education": {
      "title": "Dzidzo yeHutano hweMhuri",
      "subtitle": "Ruzivo rwechokwadi rwekuchengetedza hutano",
      "categories": "Zvikamu",
      "infant": "Kuchengeta mucheche",
      "child": "Kukura kwemwana",
      "nutrition": "Zvekudya nekukura",
      "safety": "Kudzivirira tsaona",
      "mental": "Hutano hwepfungwa",
      "hygiene": "Hutsanana netsika dzakanaka",
      "searchPlaceholder": "Tsvaga zvehutano...",
      "popularTopics": "Zvinonyanya kudiwa",
      "readMore": "Verenga zvimwe",
      "readTime": "min yekuverenga"
    },
    "reminders": {
      "title": "Zviyeuchidzo zvehutano hwemhuri",
      "subtitle": "Tevedzera zvirongwa zvekuchengetedza hutano hwemhuri yose",
      "createReminder": "Gadzira chiyeuchidzo",
      "familyMember": "Mutezo wemhuri",
      "reminderType": "Rudzi rwechiyeuchidzo",
      "frequency": "Kugara kuchiitika",
      "activeReminders": "Zviyeuchidzo zviripo",
      "upcomingThisWeek": "Zvevhiki rino",
      "noActiveReminders": "Hapana zviyeuchidzo zviripo",
      "types": {
        "checkup": "Kuongororwa hutano",
        "dental": "Kuona chiremba wemeno",
        "vision": "Kuongororwa maziso",
        "vaccine": "Kubayiwa nhomba",
        "medication": "Kudya mushonga",
        "custom": "Zvimwe"
      }
    },
    "planner": {
      "title": "Zvekuronga zvehutano hwemhuri",
      "subtitle": "Rongai kuchengetedzwa kwehutano hwemhuri yenyu",
      "addMember": "Wedzera mutezo wemhuri",
      "memberName": "Zita remutezo",
      "relationship": "Hukama",
      "dateOfBirth": "Zuva rekuzvarwa",
      "viewCalendar": "Ona karenda",
      "upcomingCare": "Zvekuchengetedza hutano zvinouya",
      "nothingScheduled": "Hapana chakarongwa parizvino",
      "scheduleCheckup": "Ronga kuongororwa",
      "relationships": {
        "child": "Mwana",
        "spouse": "Wawakaroorana naye",
        "parent": "Mubereki",
        "sibling": "Hama",
        "other": "Zvimwe"
      }
    },
    "content": {
      "infantCare": {
        "title": "Kuchengeta hutano hweMucheche",
        "intro": "Matanho akakosha ekuchengetedza mucheche mugore rake rekutanga",
        "topics": [
          "Mazuva ekuongororwa kwemucheche",
          "Kukura kwemwana kwekutarisa",
          "Kuradzika mwana zvakachengeteka",
          "Kudyisa nemidyo inovaka muviri",
          "Mazuva ekubayiwa nhomba"
        ]
      },
      "childDevelopment": {
        "title": "Kukura kweMwana neMatanho",
        "intro": "Kunzwisisa kukura kwakanaka kwemwana",
        "topics": [
          "Kukura kwemuviri",
          "Kukura mumafungiro nemagariro",
          "Kutaura kwemwana",
          "Kushanda kwepfungwa",
          "Nguva yekutaura nachiremba"
        ]
      },
      "nutrition": {
        "title": "Zvekudya neKukura",
        "intro": "Kudzidzisa mwana kudya zvinovaka muviri kubva achiri mudiki",
        "topics": [
          "Zvekudya zvinoenderana nezera",
          "Mazano ezvekudya zvishoma zvine hutano",
          "Kudyisa mwana anonetsa pakudya",
          "Kuchengetedza hutsanana hwekudya",
          "Kunwa mvura"
        ]
      },
      "safety": {
        "title": "Kudzivirira Tsaona",
        "intro": "Kugadzira nzvimbo yakachengeteka yemhuri yako",
        "topics": [
          "Zvekutarisa mumba kuti pachengeteke",
          "Kugara zvakanaka mumotokari",
          "Kuchengeteka mumvura",
          "Kudzivirira chepfu",
          "Kugadzirira tsaona dzinongoitika"
        ]
      }
    }
  }
};
